var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuturaCyrillicDemi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20190801 at Wed Dec 29 15:18:52 2021\n By www-data\nCopyright (c) 1995 ParaGraph Intl., (c) 1998 ParaType Inc., ParaType Ltd. All rights reserved.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "FuturaCyrillicDemi",
    horizAdvX: 500
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "FuturaCyrillicDemi",
    fontWeight: 500,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 7 2 2 2 4 2 3 3",
    ascent: 763,
    descent: -237,
    xHeight: 433,
    capHeight: 667,
    bbox: "-368 -270 1140 930",
    underlineThickness: 50,
    underlinePosition: -100,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10017.var.accented",
    unicode: "\u0410`",
    horizAdvX: 672,
    d: "M530 0l-59 140h-269l-59 -140h-141l287 667h102l279 -667h-140zM243 246h190l-95 240zM312 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10022.var.accented",
    unicode: "\u0415`",
    horizAdvX: 496,
    d: "M446 667v-112h-240v-149h230v-112h-230v-182h240v-112h-370v667h370zM224 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10026.var.accented",
    unicode: "\u0418`",
    horizAdvX: 740,
    d: "M76 667h130v-444l366 444h92v-667h-130v446l-366 -446h-92v667zM346 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10032.var.accented",
    unicode: "\u041E`",
    horizAdvX: 800,
    d: "M400 682q157 0 256.5 -98t99.5 -251t-99.5 -250.5t-256.5 -97.5t-256.5 97.5t-99.5 250.5t99.5 251t256.5 98zM400 103q98 0 160 64.5t62 165.5t-62.5 166t-159.5 65t-159.5 -65t-62.5 -166t62 -165.5t160 -64.5zM376 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10037.var.accented",
    unicode: "\u0423`",
    horizAdvX: 610,
    d: "M2 667h152l169 -336l143 336h142l-309 -667h-142l93 186zM281 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10045.var.accented",
    unicode: "\u042B`",
    horizAdvX: 800,
    d: "M76 0v667h130v-261h104q104 0 164 -55q62 -57 62 -149q0 -68 -36 -120q-56 -82 -189 -82h-235zM206 294v-182h76q120 0 120 90q0 38 -26.5 65t-91.5 27h-78zM594 667h130v-667h-130v667zM376 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10047.var.accented",
    unicode: "\u042D`",
    horizAdvX: 611,
    d: "M44 24v152q72 -73 176 -73q78 0 138.5 46t74.5 130h-299v112h297q-14 82 -73 127.5t-133 45.5q-107 0 -181 -75v152q80 41 174 41q157 0 249 -88q47 -46 73.5 -115.5t26.5 -145.5q0 -159 -99 -255q-93 -93 -249 -93q-94 0 -175 39zM231 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10048.var.accented",
    unicode: "\u042E`",
    horizAdvX: 1026,
    d: "M206 409h92q17 98 84 171q94 102 256 102q153 0 248.5 -98t95.5 -251q0 -152 -95.5 -250t-248.5 -98q-151 0 -243 89t-101 223h-88v-297h-130v667h130v-258zM638 103q94 0 152 64t58 166q0 112 -63.5 171.5t-146.5 59.5t-146.5 -59.5t-63.5 -171.5q0 -102 58 -166 t152 -64zM489 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10049.var.accented",
    unicode: "\u042F`",
    horizAdvX: 568,
    d: "M492 667v-667h-130v258h-24l-170 -258h-156l198 270q-40 6 -73 30q-75 54 -75 161q0 97 66 155q58 51 171 51h193zM362 561h-40q-16 0 -31 -2t-40 -10.5t-40 -31t-15 -56.5q0 -101 128 -101h38v201zM260 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10023.var.accented",
    unicode: "\u0401`",
    horizAdvX: 496,
    d: "M446 667v-112h-240v-149h230v-112h-230v-182h240v-112h-370v667h370zM206 743l-35 33l112 144l62 -57zM49 823q0 21 17 40.5t43 19.5t43.5 -18t17.5 -42q0 -23 -18 -42t-43 -19q-23 0 -41.5 18.5t-18.5 42.5zM351 823q0 21 17 40.5t44 19.5t44 -19.5t17 -40.5 q0 -23 -19 -42t-42 -19t-42 19t-19 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10065.var.accented",
    unicode: "\u0430`",
    horizAdvX: 570,
    d: "M390 377v56h122v-433h-122v56q-49 -70 -133 -70q-98 0 -159.5 67t-61.5 164q0 98 60 164t155 66q94 0 139 -70zM282 339q-52 0 -86 -35t-34 -87t34 -87.5t86 -35.5t86 35.5t34 87.5t-34 87t-86 35zM353 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10070.var.accented",
    unicode: "\u0435`",
    horizAdvX: 522,
    d: "M371 139l112 -18q-7 -18 -18.5 -35.5t-35.5 -43t-65 -41t-94 -15.5q-102 0 -166 61q-68 64 -68 169q0 104 66 170q62 61 163 61q110 0 169 -71q52 -62 52 -170v-10h-324q0 -44 21 -73q30 -41 87 -41q68 0 101 57zM166 274h205q-7 42 -36.5 64.5t-66.5 22.5 q-36 0 -65.5 -23t-36.5 -64zM329 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10074.var.accented",
    unicode: "\u0438`",
    horizAdvX: 560,
    d: "M58 433h122v-267l200 267h122v-433h-122v267l-200 -267h-122v433zM348 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10080.var.accented",
    unicode: "\u043E`",
    horizAdvX: 568,
    d: "M284 447q109 0 175 -61q73 -66 73 -170q0 -103 -73 -169q-66 -61 -175 -61t-175 61q-73 66 -73 169q0 104 73 170q66 61 175 61zM284 94q52 0 87 36t35 86q0 51 -35 87t-87 36t-87 -36t-35 -87q0 -50 35 -86t87 -36zM352 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10085.var.accented",
    unicode: "\u0443`",
    horizAdvX: 538,
    d: "M49 -229l159 294l-206 368h142l134 -246l120 246h138l-349 -662h-138zM337 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10093.var.accented",
    unicode: "\u044B`",
    horizAdvX: 650,
    d: "M58 433h122v-154h95q76 0 116 -44q33 -35 33 -93q0 -71 -46 -110q-37 -32 -97 -32h-223v433zM180 96h57q31 0 45 11q16 12 16 35q0 21 -16 31q-14 10 -42 10h-60v-87zM470 433h122v-433h-122v433zM393 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10095.var.accented",
    unicode: "\u044D`",
    horizAdvX: 434,
    d: "M34 9v118q52 -42 126 -42q52 0 80 24q27 24 29 66h-179v88h179q-6 39 -33 61q-30 27 -77 27q-69 0 -123 -37v106q65 27 132 27q108 0 169 -65q61 -63 61 -166q0 -107 -64 -169q-62 -62 -166 -62q-78 0 -134 24zM241 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10096.var.accented",
    unicode: "\u044E`",
    horizAdvX: 750,
    d: "M180 270h59q11 67 62 116q64 61 169 61q106 0 172 -61q72 -65 72 -170q0 -102 -72 -169q-66 -61 -172 -61q-104 0 -169 61q-51 49 -62 119h-59v-166h-122v433h122v-163zM470 94q51 0 84.5 35.5t33.5 86.5q0 52 -33.5 87.5t-84.5 35.5t-84.5 -35.5t-33.5 -87.5 q0 -51 33.5 -86.5t84.5 -35.5zM443 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10097.var.accented",
    unicode: "\u044F`",
    horizAdvX: 460,
    d: "M20 0l128 162q-42 6 -70 34q-34 34 -34 92q0 67 52 109q46 36 134 36h172v-433h-122v152h-14l-106 -152h-140zM280 240v97h-53q-28 0 -41 -12q-16 -15 -16 -38q0 -24 16 -36q14 -11 41 -11h53zM298 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10071.var.accented",
    unicode: "\u0451`",
    horizAdvX: 522,
    d: "M371 139l112 -18q-7 -18 -18.5 -35.5t-35.5 -43t-65 -41t-94 -15.5q-102 0 -166 61q-68 64 -68 169q0 104 66 170q62 61 163 61q110 0 169 -71q52 -62 52 -170v-10h-324q0 -44 21 -73q30 -41 87 -41q68 0 101 57zM166 274h205q-7 42 -36.5 64.5t-66.5 22.5 q-36 0 -65.5 -23t-36.5 -64zM293 700l67 -41l-135 -137l-40 28zM52 593q0 27 19 46t45 19q27 0 46 -19t19 -46q0 -26 -19 -45t-46 -19q-26 0 -45 19t-19 45zM348 593q0 26 19 45.5t46 19.5q26 0 45.5 -19t19.5 -46q0 -26 -19.5 -45t-45.5 -19q-27 0 -46 19t-19 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 528,
    d: "M294 329h-112v-329h-122v329h-46v104h46v108q0 31 1 45t8.5 38t22.5 45q54 72 173 72q127 0 175 -72q5 -8 9.5 -16t7.5 -16.5t5.5 -15t3.5 -16t2 -14t1.5 -14.5t0.5 -12.5v-12.5v-11v-29h-122v26q0 39 -13 60q-21 33 -70 33q-48 0 -69 -33q-14 -22 -14 -60v-105h112v-104 zM348 433h122v-433h-122v433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 528,
    d: "M294 329h-112v-329h-122v329h-46v104h46v108q0 31 1 45t8.5 38t22.5 45q54 72 173 72q127 0 175 -72q5 -8 9.5 -16t7.5 -16.5t5.5 -15t3.5 -16t2 -14t1.5 -14.5t0.5 -12.5v-12.5v-11v-541h-122v538q0 39 -13 60q-21 33 -70 33q-48 0 -69 -33q-14 -22 -14 -60v-105h112 v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 252,
    d: "M188 203h-124v464h124v-464zM48 65q0 33 22.5 55.5t55.5 22.5t55.5 -22.5t22.5 -55.5t-22.5 -55.5t-55.5 -22.5t-55.5 22.5t-22.5 55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 388,
    d: "M172 667l-23 -268h-84l-23 268h130zM346 667l-23 -268h-84l-23 268h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 600,
    d: "M420 0h-122l30 186h-94l-30 -186h-122l30 186h-102l17 104h102l16 101h-102l17 104h102l28 172h122l-28 -172h94l28 172h122l-28 -172h102l-17 -104h-102l-16 -101h102l-17 -104h-102zM345 290l16 101h-94l-16 -101h94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 568,
    d: "M248 765h82v-100q42 -3 82 -23q41 -22 68 -52l-66 -84q-44 54 -105 54q-45 0 -68 -24q-19 -19 -19 -47t26 -47q15 -11 82 -41q5 -2 23.5 -10t27.5 -12.5t23.5 -12t25.5 -16t21 -17.5q51 -48 51 -124q0 -91 -60 -149q-45 -45 -112 -58v-112h-82v110q-70 8 -127 46 q-43 29 -73 73l75 77q27 -40 57 -60q38 -28 91 -28q49 0 76 26q25 25 25 62q0 30 -23 55q-12 13 -72 39q-90 36 -133 77q-47 44 -47 115t45 122q43 47 106 61v100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 774,
    d: "M198 675q77 0 122.5 -44.5t45.5 -113.5t-45.5 -113.5t-122.5 -44.5t-122.5 44.5t-45.5 113.5t45.5 113.5t122.5 44.5zM198 431q37 0 60.5 24t23.5 62t-23.5 62t-60.5 24t-60.5 -24t-23.5 -62t23.5 -62t60.5 -24zM162 3l397 686l53 -30l-397 -687zM576 306 q77 0 122.5 -44.5t45.5 -113.5t-45.5 -113.5t-122.5 -44.5t-122.5 44.5t-45.5 113.5t45.5 113.5t122.5 44.5zM576 62q37 0 60.5 24t23.5 62t-23.5 62t-60.5 24t-60.5 -24t-23.5 -62t23.5 -62t60.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 710,
    d: "M578 324l76 -75q-36 -45 -72 -81l-15 -15l135 -153h-161l-65 75q-100 -90 -215 -90q-97 0 -153 57t-56 134q0 105 107 169l52 31q-67 67 -67 140q0 68 48 117t136 49q83 0 131 -47t48 -112q0 -91 -94 -148l-28 -17l110 -126q54 53 83 92zM403 157l-126 145 q-95 -50 -95 -115q0 -38 28 -63t70 -25q65 0 123 58zM294 463l29 -36l30 21q46 32 46 74q0 27 -16.5 46.5t-48.5 19.5q-33 0 -50.5 -18.5t-17.5 -43.5q0 -29 28 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 214,
    d: "M172 667l-23 -268h-84l-23 268h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 320,
    d: "M264 -127l-97 -53q-48 90 -74 206q-25 114 -25 254q0 131 23 240q26 119 76 220l97 -53q-33 -68 -55 -168q-25 -122 -25 -239q0 -128 25 -243q19 -91 55 -164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 320,
    d: "M153 -180l-97 53q36 73 55 164q25 115 25 243q0 117 -25 239q-22 100 -55 168l97 53q50 -101 76 -220q23 -109 23 -240q0 -140 -25 -254q-26 -116 -74 -206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 568,
    d: "M144 681l114 -58l-20 126h92l-20 -126l114 59l28 -88l-127 -20l91 -90l-75 -54l-57 115l-57 -116l-75 54l91 91l-127 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    d: "M33 283v112h156v156h122v-156h156v-112h-156v-156h-122v156h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 328,
    d: "M4 -131l106 269l112 -13l-141 -265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 360,
    d: "M50 174v112h260v-112h-260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 252,
    d: "M48 65q0 33 22.5 55.5t55.5 22.5t55.5 -22.5t22.5 -55.5t-22.5 -55.5t-55.5 -22.5t-55.5 22.5t-22.5 55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 653,
    d: "M-20 -170l525 929l88 -40l-525 -929z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 568,
    d: "M284 -15q-107 0 -182.5 92.5t-75.5 256.5q0 163 75.5 255.5t182.5 92.5t182.5 -92.5t75.5 -256.5q0 -163 -75.5 -255.5t-182.5 -92.5zM284 570q-49 0 -88.5 -58.5t-39.5 -177.5t39 -178t89 -59t89 59t39 178t-39.5 177.5t-88.5 58.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 568,
    d: "M228 0v555h-96v112h226v-667h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 568,
    d: "M18 0l196 223q96 112 114 139q39 58 39 107q0 45 -28.5 73t-70.5 28q-48 0 -76 -32.5t-30 -78.5h-134q4 101 69 162t165 61q110 0 172.5 -63t62.5 -149q0 -48 -22 -96t-42 -72.5t-57 -64.5l-115 -125h241v-112h-484z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 568,
    d: "M173 493h-122q9 89 69 139t148 50q96 0 152.5 -50t56.5 -134q0 -97 -77 -140q102 -42 102 -159q0 -100 -67.5 -157t-170.5 -57q-98 0 -165 56.5t-75 150.5h130q6 -43 35 -69t76 -26q52 0 79.5 31.5t27.5 74.5q0 42 -27.5 73t-83.5 31h-17v94h18q45 0 68 26.5t23 64.5 q0 40 -24 64t-64 24q-37 0 -63.5 -23t-28.5 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 568,
    d: "M470 667v-437h78v-104h-78v-126h-122v126h-326v58l331 483h117zM176 230h172v254z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 568,
    d: "M472 667v-112h-222l-24 -105q26 4 45 4q107 0 172 -67q59 -60 59 -160q0 -106 -68 -174t-183 -68q-87 0 -144 28q-43 21 -81 57l43 112q29 -39 69 -60q46 -25 97 -25q64 0 102 40q35 37 35 97q0 57 -39 92q-39 34 -104 34q-72 0 -144 -43l79 350h308z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 568,
    d: "M310 685l105 -51l-162 -211q36 16 73 16q88 0 147 -57q63 -59 63 -160q0 -95 -61 -161q-70 -76 -190 -76q-122 0 -190 68q-65 65 -65 162t84 208zM283 89q53 0 87 34q36 36 36 88q0 57 -37 92q-33 32 -86 32t-87 -36q-36 -37 -36 -87q0 -56 37 -90q35 -33 86 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 568,
    d: "M49 29l307 526h-310v112h514l-401 -687z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 568,
    d: "M397 348q55 -18 87 -63t32 -103q0 -85 -63.5 -141t-168.5 -56t-168.5 56t-63.5 141q0 58 32 103t87 63q-42 21 -69 58.5t-27 89.5q0 78 55 132t154 54t154 -54t55 -132q0 -52 -27 -89.5t-69 -58.5zM284 402q41 0 67 26t26 67t-26 67t-67 26t-67 -26t-26 -67t26 -67 t67 -26zM284 87q44 0 73 29.5t29 74.5t-29 74.5t-73 29.5t-73 -29.5t-29 -74.5t29 -74.5t73 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 568,
    d: "M258 -18l-105 51l159 208q-39 -13 -71 -13q-37 0 -77.5 15t-68.5 42q-63 59 -63 160q0 95 61 161q70 76 190 76q122 0 190 -68q65 -65 65 -162t-84 -208zM285 578q-53 0 -87 -34q-36 -36 -36 -88q0 -57 37 -92q33 -32 86 -32q52 0 87 36q36 38 36 87q0 55 -37 90 q-35 33 -86 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 252,
    d: "M48 369q0 33 22.5 55.5t55.5 22.5t55.5 -22.5t22.5 -55.5t-22.5 -55.5t-55.5 -22.5t-55.5 22.5t-22.5 55.5zM48 64q0 33 22.5 55.5t55.5 22.5t55.5 -22.5t22.5 -55.5t-22.5 -55.5t-55.5 -22.5t-55.5 22.5t-22.5 55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 328,
    d: "M84 369q0 33 22.5 55.5t55.5 22.5t55.5 -22.5t22.5 -55.5t-22.5 -55.5t-55.5 -22.5t-55.5 22.5t-22.5 55.5zM4 -131l106 269l112 -13l-141 -265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    d: "M161 334l306 -150v-120l-434 218v104l434 218v-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    d: "M33 372v106h434v-106h-434zM33 200v106h434v-106h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    d: "M339 334l-306 150v120l434 -218v-104l-434 -218v120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 490,
    d: "M283 203h-124v196q16 -4 39 -4q60 0 94 34q26 28 26 67q0 37 -21 58q-20 20 -52 20q-33 0 -51 -18q-22 -20 -22 -65h-130q0 81 50 135q54 56 158 56q94 0 146 -51q52 -50 52 -138q0 -78 -51 -129q-47 -47 -114 -56v-105zM143 63q0 33 22.5 55.5t55.5 22.5t55.5 -22.5 t22.5 -55.5t-22.5 -55.5t-55.5 -22.5t-55.5 22.5t-22.5 55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 734,
    d: "M468 450l8 42h84l-40 -203q-4 -20 -4 -34q0 -34 26 -34q22 0 46 33q39 53 39 125q0 90 -61.5 157t-177.5 67q-87 0 -151 -43.5t-93 -104.5t-29 -128q0 -83 44 -151.5t117 -95.5q48 -17 111 -17q96 0 187 33l19 -76q-95 -32 -200 -32q-160 0 -255 88q-53 49 -79 115.5 t-26 136.5q0 155 101.5 252.5t253.5 97.5q147 0 230 -86t83 -206q0 -100 -50.5 -166.5t-114.5 -66.5q-28 0 -49.5 14.5t-27.5 41.5q-46 -64 -123 -64q-60 0 -100.5 41.5t-40.5 115.5q0 92 53.5 146t120.5 54q69 0 99 -52zM358 230q34 0 61 31t27 80q0 31 -16.5 52.5 t-48.5 21.5q-38 0 -64.5 -31.5t-26.5 -77.5q0 -37 20.5 -56.5t47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 672,
    d: "M530 0l-59 140h-269l-59 -140h-141l287 667h102l279 -667h-140zM243 246h190l-95 240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 570,
    d: "M76 667h165q109 0 163 -42q62 -48 62 -138q0 -89 -75 -131q51 -8 87 -42q48 -46 48 -125q0 -84 -57 -135q-61 -54 -169 -54h-224v667zM206 561v-171h37q10 0 18.5 0.5t25 5.5t28 13.5t20.5 26t9 41.5q0 43 -28 63.5t-72 20.5h-38zM206 290v-184h56q58 0 89 18 q41 24 41 77q0 54 -49 76q-28 13 -89 13h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 604,
    d: "M560 176v-152q-74 -39 -165 -39q-146 0 -244 93q-107 103 -107 255q0 162 107 261q94 88 245 88q88 0 164 -41v-152q-65 75 -161 75q-98 0 -159.5 -68.5t-61.5 -164.5q0 -105 68 -166.5t158 -61.5q94 0 156 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 670,
    d: "M76 667h174q79 0 138 -13.5t110 -51.5q61 -46 94.5 -116t33.5 -153q0 -175 -134 -269q-54 -38 -110 -51t-134 -13h-172v667zM206 555v-443h40q102 0 163 44q39 28 61 75.5t22 101.5q0 53 -21.5 100.5t-60.5 77.5q-59 44 -164 44h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 496,
    d: "M446 667v-112h-240v-149h230v-112h-230v-182h240v-112h-370v667h370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 466,
    d: "M430 667v-112h-224v-149h210v-112h-210v-294h-130v667h354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 764,
    d: "M414 245v112h306v-8q0 -179 -98 -276q-88 -88 -237 -88q-152 0 -242 90q-99 99 -99 257q0 150 98 248q100 102 263 102q88 0 154 -35q77 -39 125 -122l-113 -61q-27 52 -78 79q-42 21 -94 21q-94 0 -154 -59q-67 -65 -67 -176q0 -105 66 -169q59 -57 148 -57q78 0 131 40 q48 37 63 102h-172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 694,
    d: "M206 667v-258h282v258h130v-667h-130v297h-282v-297h-130v667h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 282,
    d: "M76 667h130v-667h-130v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 390,
    d: "M184 667h130v-450q0 -149 -78 -202q-46 -30 -109 -30q-88 0 -153 62l79 95q25 -36 65 -36q36 0 51 23q15 22 15 108v430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 636,
    d: "M206 667v-282l245 282h164l-282 -308l297 -359h-172l-237 299l-15 -15v-284h-130v667h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 426,
    d: "M76 667h130v-555h206v-112h-336v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 870,
    d: "M42 0l124 667h94l177 -424l185 424h94l112 -667h-132l-60 411l-179 -411h-44l-171 411l-68 -411h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 778,
    d: "M206 0h-130v667h90l406 -445v445h130v-667h-90l-406 446v-446z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 800,
    d: "M400 682q157 0 256.5 -98t99.5 -251t-99.5 -250.5t-256.5 -97.5t-256.5 97.5t-99.5 250.5t99.5 251t256.5 98zM400 103q98 0 160 64.5t62 165.5t-62.5 166t-159.5 65t-159.5 -65t-62.5 -166t62 -165.5t160 -64.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 534,
    d: "M76 667h194q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -161q0 -94 -55 -149q-59 -59 -169 -59h-84v-247h-130v667zM206 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 800,
    d: "M645 -26l-55 59q-81 -48 -190 -48q-157 0 -256.5 97.5t-99.5 250.5t99.5 251t256.5 98t256.5 -98t99.5 -251q0 -139 -88 -237l108 -109zM501 268l77 -79q44 59 44 144q0 101 -62.5 166t-159.5 65t-159.5 -65t-62.5 -166t62.5 -165.5t162.5 -64.5q55 0 99 22l-136 132z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 574,
    d: "M76 667h193q110 0 170 -50q66 -56 66 -150q0 -105 -78 -157q-30 -21 -73 -29l208 -281h-162l-178 268h-16v-268h-130v667zM206 561v-201h37q16 0 31.5 2.5t40.5 11t40.5 31t15.5 56.5t-15 56.5t-40 31t-40 10.5t-31 2h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 534,
    d: "M472 604l-68 -89q-43 57 -109 57q-48 0 -70 -23.5t-22 -54.5q0 -27 21 -45q16 -15 80 -38q99 -34 135 -67q57 -51 57 -140q0 -98 -64.5 -158.5t-167.5 -60.5q-144 0 -230 126l85 81q22 -45 61 -67t79 -22q45 0 74 25.5t29 66.5q0 35 -26 60q-24 22 -103 49 q-74 25 -111 58q-53 46 -53 124q0 81 55 138.5t159 57.5q113 0 189 -78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 442,
    d: "M436 555h-150v-555h-130v555h-150v112h430v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 688,
    d: "M76 667h130v-419q0 -63 32 -99q38 -46 106 -46t106 46q32 36 32 99v419h130v-408q0 -114 -50 -178q-35 -46 -93.5 -71t-124.5 -25t-124.5 25t-93.5 71q-50 64 -50 178v408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 644,
    d: "M2 667h142l178 -448l178 448h142l-282 -667h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 978,
    d: "M485 423l-153 -423h-98l-232 667h138l149 -454l163 460h72l154 -460l160 454h138l-247 -667h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 640,
    d: "M8 0l236 352l-199 315h156l117 -207l123 207h156l-205 -315l228 -352h-156l-146 244l-154 -244h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 590,
    d: "M227 0v305l-229 362h154l143 -232l143 232h154l-235 -362v-305h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 584,
    d: "M562 667l-324 -555h308v-112h-524l324 555h-273v112h489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 350,
    d: "M300 625h-94v-701h94v-104h-210v909h210v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 653,
    d: "M673 -170l-88 -40l-525 929l88 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 350,
    d: "M50 -76h94v701h-94v104h210v-909h-210v104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    d: "M250 577l-115 -241h-127l162 331h160l162 -331h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    d: "M0 -158v104h500v-104h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    d: "M244 510l-150 134l88 56l118 -150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 570,
    d: "M390 377v56h122v-433h-122v56q-49 -70 -133 -70q-98 0 -159.5 67t-61.5 164q0 98 60 164t155 66q94 0 139 -70zM282 339q-52 0 -86 -35t-34 -87t34 -87.5t86 -35.5t86 35.5t34 87.5t-34 87t-86 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 570,
    d: "M180 729v-352q50 70 141 70q95 0 154 -65t59 -165t-60.5 -165.5t-155.5 -65.5q-87 0 -138 70v-56h-122v729h122zM288 339q-52 0 -86 -35t-34 -87t34 -87.5t86 -35.5t86 35.5t34 87.5t-34 87t-86 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 418,
    d: "M384 421v-120q-41 38 -100 38q-58 0 -90 -35.5t-32 -86.5q0 -53 35.5 -88t90.5 -35q54 0 96 38v-119q-54 -27 -112 -27q-101 0 -167 63q-69 65 -69 166q0 110 75 176q63 56 156 56q63 0 117 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 570,
    d: "M390 377v352h122v-729h-122v56q-49 -70 -133 -70q-98 0 -159.5 67t-61.5 164q0 98 60 164t155 66q94 0 139 -70zM282 339q-52 0 -86 -35t-34 -87t34 -87.5t86 -35.5t86 35.5t34 87.5t-34 87t-86 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 522,
    d: "M371 139l112 -18q-7 -18 -18.5 -35.5t-35.5 -43t-65 -41t-94 -15.5q-102 0 -166 61q-68 64 -68 169q0 104 66 170q62 61 163 61q110 0 169 -71q52 -62 52 -170v-10h-324q0 -44 21 -73q30 -41 87 -41q68 0 101 57zM166 274h205q-7 42 -36.5 64.5t-66.5 22.5 q-36 0 -65.5 -23t-36.5 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 292,
    d: "M294 329h-112v-329h-122v329h-46v104h46v119q0 106 57 153q43 36 107 36q38 0 70 -15v-111q-24 18 -55 18q-29 0 -44 -22q-13 -21 -13 -75v-103h112v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 568,
    d: "M388 377v56h122v-413q0 -61 -11.5 -106.5t-48.5 -82.5q-61 -61 -171 -61q-106 0 -162 50q-53 45 -70 129h132q8 -33 30 -52q25 -23 74 -23q45 0 74 27q31 30 31 96v61q-47 -72 -133 -72q-90 0 -150 59q-69 69 -69 172q0 107 67 172q60 58 149 58q90 0 136 -70zM282 339 q-49 0 -81 -30q-39 -35 -39 -92q0 -51 32 -85q35 -38 88 -38q48 0 81 30q39 36 39 93q0 50 -35 87q-34 35 -85 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 534,
    d: "M58 0v729h122v-352q50 70 134 70q85 0 128 -53q34 -42 34 -122v-272h-122v236q0 61 -23 85q-21 22 -57 22q-50 0 -75 -38q-19 -30 -19 -84v-221h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 238,
    d: "M58 433h122v-433h-122v433zM46 616q0 30 21.5 51.5t51.5 21.5t51.5 -21.5t21.5 -51.5t-21.5 -51.5t-51.5 -21.5t-51.5 21.5t-21.5 51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 238,
    d: "M58 433h122v-662h-122v662zM46 616q0 30 21.5 51.5t51.5 21.5t51.5 -21.5t21.5 -51.5t-21.5 -51.5t-51.5 -21.5t-51.5 21.5t-21.5 51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 512,
    d: "M58 729h122v-454l162 158h158l-203 -190l219 -243h-162l-161 185l-13 -12v-173h-122v729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 238,
    d: "M58 729h122v-729h-122v729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 790,
    d: "M58 0v433h122v-49q50 63 129 63q97 0 137 -79q49 79 139 79q76 0 117 -53q19 -25 24.5 -52t5.5 -70v-272h-122v236q0 61 -20 85q-18 22 -50 22q-46 0 -67 -38q-17 -28 -17 -84v-221h-122v236q0 61 -20 85q-18 22 -50 22q-46 0 -67 -38q-17 -28 -17 -84v-221h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 534,
    d: "M58 0v433h122v-56q50 70 134 70q85 0 128 -53q34 -42 34 -122v-272h-122v236q0 61 -23 85q-21 22 -57 22q-50 0 -75 -38q-19 -30 -19 -84v-221h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 568,
    d: "M284 447q109 0 175 -61q73 -66 73 -170q0 -103 -73 -169q-66 -61 -175 -61t-175 61q-73 66 -73 169q0 104 73 170q66 61 175 61zM284 94q52 0 87 36t35 86q0 51 -35 87t-87 36t-87 -36t-35 -87q0 -50 35 -86t87 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 570,
    d: "M180 56v-285h-122v662h122v-56q49 70 141 70q90 0 148 -58q65 -65 65 -172q0 -110 -68 -175q-60 -56 -147 -56t-139 70zM288 339q-47 0 -79 -29q-41 -35 -41 -93q0 -59 40 -94q33 -29 80 -29q49 0 82 31q38 35 38 92q0 56 -37 91q-34 31 -83 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 570,
    d: "M390 -229v285q-52 -70 -139 -70t-147 56q-68 65 -68 175q0 107 65 172q58 58 148 58q92 0 141 -70v56h122v-662h-122zM282 339q-49 0 -83 -31q-37 -35 -37 -91q0 -57 38 -92q33 -31 82 -31q47 0 80 29q40 35 40 94q0 58 -41 93q-32 29 -79 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 360,
    d: "M58 0v433h122v-65q22 42 54 60q30 19 72 19q24 0 52 -10l-16 -114q-23 16 -57 16q-53 0 -81 -35q-24 -30 -24 -96v-208h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 404,
    d: "M354 401l-60 -71q-31 29 -71 29q-22 0 -34.5 -9.5t-12.5 -25.5q0 -26 39 -39l29 -9q85 -27 110 -62q22 -30 22 -72q0 -66 -48 -110q-50 -46 -130 -46q-101 0 -168 72l64 74q43 -50 96 -50q26 0 43 12.5t17 34.5q0 30 -38 44l-28 10q-65 23 -93 52q-33 35 -33 83 q0 60 45 98q39 31 113 31q78 0 138 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 270,
    d: "M264 329h-84v-329h-122v329h-48v104h48v148h122v-148h84v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 536,
    d: "M58 433h122v-245q0 -52 26 -76q25 -22 62 -22t62 22q26 24 26 76v245h122v-265q0 -87 -53 -133q-56 -49 -157 -49t-157 49q-53 46 -53 133v265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 504,
    d: "M2 433h136l114 -244l114 244h136l-218 -433h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 792,
    d: "M396 255l-114 -255h-60l-220 433h136l114 -250l116 250h56l116 -250l114 250h136l-220 -433h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 566,
    d: "M2 0l206 236l-166 197h154l88 -112l90 112h154l-169 -197l205 -236h-156l-124 151l-126 -151h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 538,
    d: "M49 -229l159 294l-206 368h142l134 -246l120 246h138l-349 -662h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 484,
    d: "M472 433l-246 -329h229v-104h-443l246 329h-208v104h422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    d: "M295 562v-163q0 -51 -12 -76.5t-48 -48.5q36 -23 48 -48.5t12 -76.5v-162q0 -33 13 -46q15 -15 68 -15h24v-104q-32 -2 -64 -2q-83 0 -118 29q-18 14 -27 35.5t-10.5 37t-1.5 41.5v181q0 40 -17 60q-13 14 -38 18v104q25 4 38 18q17 20 17 60v182q0 26 1.5 41.5t10.5 37 t27 35.5q35 29 118 29q32 0 64 -2v-104h-24q-53 0 -68 -15q-13 -13 -13 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    d: "M189 -250v1000h122v-1000h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    d: "M205 399v163q0 33 -13 46q-15 15 -68 15h-24v104q32 2 64 2q83 0 118 -29q18 -14 27 -35.5t10.5 -37t1.5 -41.5v-182q0 -40 17 -60q13 -14 38 -18v-104q-25 -4 -38 -18q-17 -20 -17 -60v-181q0 -26 -1.5 -41.5t-10.5 -37t-27 -35.5q-35 -29 -118 -29q-32 0 -64 2v104h24 q53 0 68 15q13 13 13 46v162q0 51 12 76.5t48 48.5q-36 23 -48 48.5t-12 76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    d: "M424 370l70 -40q-37 -88 -92 -116q-30 -15 -59 -15q-35 0 -106 27q-67 25 -90 25q-20 0 -37 -14t-23.5 -26t-10.5 -23l-70 40q30 86 77 119q28 21 71 21q35 0 108 -27q71 -25 88 -25q46 0 74 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10023",
    unicode: "\u0401",
    horizAdvX: 496,
    d: "M446 667v-112h-240v-149h230v-112h-230v-182h240v-112h-370v667h370zM76 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM300 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5 t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10051",
    unicode: "\u0402",
    horizAdvX: 660,
    d: "M496 555h-220v-170q65 23 137 23q85 0 136 -30q91 -52 91 -175q0 -121 -76 -172q-53 -37 -147 -37q-31 0 -67 6v112q33 -6 64 -6q42 0 63 18q29 24 29 74q0 61 -41 84q-25 14 -69 14q-60 0 -120 -23v-273h-130v555h-140v112h490v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10052",
    unicode: "\u0403",
    horizAdvX: 436,
    d: "M430 667v-112h-224v-555h-130v667h354zM256 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10053",
    unicode: "\u0404",
    horizAdvX: 611,
    d: "M567 176v-152q-81 -39 -175 -39q-156 0 -249 93q-99 96 -99 255q0 76 26.5 145.5t73.5 115.5q92 88 249 88q94 0 174 -41v-152q-67 75 -175 75q-83 0 -141 -49.5t-73 -123.5h319v-112h-319q15 -83 78.5 -129.5t142.5 -46.5q101 0 168 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10054",
    unicode: "\u0405",
    horizAdvX: 534,
    d: "M472 604l-68 -89q-43 57 -109 57q-48 0 -70 -23.5t-22 -54.5q0 -27 21 -45q16 -15 80 -38q99 -34 135 -67q57 -51 57 -140q0 -98 -64.5 -158.5t-167.5 -60.5q-144 0 -230 126l85 81q22 -45 61 -67t79 -22q45 0 74 25.5t29 66.5q0 35 -26 60q-24 22 -103 49 q-74 25 -111 58q-53 46 -53 124q0 81 55 138.5t159 57.5q113 0 189 -78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10055",
    unicode: "\u0406",
    horizAdvX: 282,
    d: "M76 667h130v-667h-130v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10056",
    unicode: "\u0407",
    horizAdvX: 282,
    d: "M76 667h130v-667h-130v667zM6 811q0 29 17 50.5t41 21.5t41 -21.5t17 -50.5t-17 -50.5t-41 -21.5t-41 21.5t-17 50.5zM156 811q0 29 17 50.5t41 21.5t41 -21.5t17 -50.5t-17 -50.5t-41 -21.5t-41 21.5t-17 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10057",
    unicode: "\u0408",
    horizAdvX: 390,
    d: "M184 667h130v-450q0 -149 -78 -202q-46 -30 -109 -30q-88 0 -153 62l79 95q25 -36 65 -36q36 0 51 23q15 22 15 108v430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10058",
    unicode: "\u0409",
    horizAdvX: 944,
    d: "M140 667h454v-261h104q104 0 164 -55q62 -57 62 -149q0 -68 -36 -120q-56 -82 -189 -82h-235v555h-194v-296q0 -38 -1 -57t-7 -54t-22 -61.5t-42 -48.5q-52 -44 -133 -44q-28 0 -55 6v112q20 -6 37 -6q36 0 60 24q16 16 23.5 44t8.5 48t1 63v382zM594 294v-182h76 q120 0 120 90q0 38 -26.5 65t-91.5 27h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10059",
    unicode: "\u040A",
    horizAdvX: 968,
    d: "M206 667v-258h282v258h130v-261h104q104 0 164 -55q62 -57 62 -149q0 -68 -36 -120q-56 -82 -189 -82h-235v297h-282v-297h-130v667h130zM618 294v-182h76q120 0 120 90q0 38 -26.5 65t-91.5 27h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10060",
    unicode: "\u040B",
    horizAdvX: 690,
    d: "M476 555h-200v-154q68 7 119 7q121 0 178 -43q67 -50 67 -160v-205h-130v182q0 66 -33 92q-29 22 -95 22q-57 0 -106 -7v-289h-130v555h-140v112h470v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10061",
    unicode: "\u040C",
    horizAdvX: 636,
    d: "M206 667v-282l245 282h164l-282 -308l297 -359h-172l-237 299l-15 -15v-284h-130v667h130zM294 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10062",
    unicode: "\u040E",
    horizAdvX: 610,
    d: "M2 667h152l169 -336l143 336h142l-309 -667h-142l93 186zM130 844l90 36q22 -58 90 -58t90 58l90 -36q-20 -52 -66.5 -82t-113.5 -30t-113.5 30t-66.5 82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10145",
    unicode: "\u040F",
    horizAdvX: 676,
    d: "M76 0v667h130v-555h264v555h130v-667h-202v-166h-120v166h-202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10017",
    unicode: "\u0410",
    horizAdvX: 672,
    d: "M530 0l-59 140h-269l-59 -140h-141l287 667h102l279 -667h-140zM243 246h190l-95 240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10018",
    unicode: "\u0411",
    horizAdvX: 570,
    d: "M76 0v667h386v-112h-256v-153h90q106 0 167 -54q63 -56 63 -148q0 -66 -37 -119q-57 -81 -192 -81h-221zM206 290v-178h62q124 0 124 87q0 38 -27.5 64.5t-94.5 26.5h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10019",
    unicode: "\u0412",
    horizAdvX: 570,
    d: "M76 667h165q109 0 163 -42q62 -48 62 -138q0 -89 -75 -131q51 -8 87 -42q48 -46 48 -125q0 -84 -57 -135q-61 -54 -169 -54h-224v667zM206 561v-171h37q10 0 18.5 0.5t25 5.5t28 13.5t20.5 26t9 41.5q0 43 -28 63.5t-72 20.5h-38zM206 290v-184h56q58 0 89 18 q41 24 41 77q0 54 -49 76q-28 13 -89 13h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10020",
    unicode: "\u0413",
    horizAdvX: 436,
    d: "M430 667v-112h-224v-555h-130v667h354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10021",
    unicode: "\u0414",
    horizAdvX: 670,
    d: "M140 667h450v-555h70v-262h-120v150h-410v-150h-120v262q34 -1 62 24.5t44 65.5q24 61 24 175v290zM266 555v-178q0 -125 -23 -186q-18 -46 -52 -79h269v443h-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10022",
    unicode: "\u0415",
    horizAdvX: 496,
    d: "M446 667v-112h-240v-149h230v-112h-230v-182h240v-112h-370v667h370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10024",
    unicode: "\u0416",
    horizAdvX: 894,
    d: "M385 667h124v-282l222 282h148l-255 -308l264 -359h-150l-214 299l-15 -15v-284h-124v284l-15 15l-214 -299h-150l264 359l-255 308h148l222 -282v282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10025",
    unicode: "\u0417",
    horizAdvX: 600,
    d: "M158 515l-68 89q87 78 205 78q101 0 160 -47.5t59 -126.5q0 -95 -82 -141q60 -15 92 -62t32 -110q0 -94 -74 -152t-191 -58q-173 0 -251 126l85 81q22 -50 69.5 -74.5t99.5 -24.5q63 0 95.5 29t32.5 70q0 102 -146 102h-60v112h60q51 0 81 22.5t30 62.5q0 37 -24 57 t-71 20q-86 0 -134 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10026",
    unicode: "\u0418",
    horizAdvX: 740,
    d: "M76 667h130v-444l366 444h92v-667h-130v446l-366 -446h-92v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10027",
    unicode: "\u0419",
    horizAdvX: 740,
    d: "M76 667h130v-444l366 444h92v-667h-130v446l-366 -446h-92v667zM190 844l90 36q22 -58 90 -58t90 58l90 -36q-20 -52 -66.5 -82t-113.5 -30t-113.5 30t-66.5 82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10028",
    unicode: "\u041A",
    horizAdvX: 636,
    d: "M206 667v-282l245 282h164l-282 -308l297 -359h-172l-237 299l-15 -15v-284h-130v667h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10029",
    unicode: "\u041B",
    horizAdvX: 670,
    d: "M140 667h454v-667h-130v555h-194v-296q0 -38 -1 -57t-7 -54t-22 -61.5t-42 -48.5q-52 -44 -133 -44q-28 0 -55 6v112q20 -6 37 -6q36 0 60 24q16 16 23.5 44t8.5 48t1 63v382z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10030",
    unicode: "\u041C",
    horizAdvX: 870,
    d: "M42 0l124 667h94l177 -424l185 424h94l112 -667h-132l-60 411l-179 -411h-44l-171 411l-68 -411h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10031",
    unicode: "\u041D",
    horizAdvX: 694,
    d: "M206 667v-258h282v258h130v-667h-130v297h-282v-297h-130v667h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10032",
    unicode: "\u041E",
    horizAdvX: 800,
    d: "M400 682q157 0 256.5 -98t99.5 -251t-99.5 -250.5t-256.5 -97.5t-256.5 97.5t-99.5 250.5t99.5 251t256.5 98zM400 103q98 0 160 64.5t62 165.5t-62.5 166t-159.5 65t-159.5 -65t-62.5 -166t62 -165.5t160 -64.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10033",
    unicode: "\u041F",
    horizAdvX: 680,
    d: "M76 667h528v-667h-130v555h-268v-555h-130v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10034",
    unicode: "\u0420",
    horizAdvX: 534,
    d: "M76 667h194q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -161q0 -94 -55 -149q-59 -59 -169 -59h-84v-247h-130v667zM206 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10035",
    unicode: "\u0421",
    horizAdvX: 604,
    d: "M560 176v-152q-74 -39 -165 -39q-146 0 -244 93q-107 103 -107 255q0 162 107 261q94 88 245 88q88 0 164 -41v-152q-65 75 -161 75q-98 0 -159.5 -68.5t-61.5 -164.5q0 -105 68 -166.5t158 -61.5q94 0 156 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10036",
    unicode: "\u0422",
    horizAdvX: 442,
    d: "M436 555h-150v-555h-130v555h-150v112h430v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10037",
    unicode: "\u0423",
    horizAdvX: 610,
    d: "M2 667h152l169 -336l143 336h142l-309 -667h-142l93 186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10038",
    unicode: "\u0424",
    horizAdvX: 830,
    d: "M350 0v92h-18q-117 0 -188 50q-100 71 -100 212t100 212q71 50 188 50h18v78h130v-78h18q117 0 188 -50q100 -71 100 -212t-100 -212q-71 -50 -188 -50h-18v-92h-130zM350 204v300h-20q-60 0 -98 -28q-54 -40 -54 -122q0 -79 54 -122q36 -28 98 -28h20zM480 504v-300h20 q63 0 99 28q53 41 53 122q0 83 -53 122q-38 28 -99 28h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10039",
    unicode: "\u0425",
    horizAdvX: 640,
    d: "M8 0l236 352l-199 315h156l117 -207l123 207h156l-205 -315l228 -352h-156l-146 244l-154 -244h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10040",
    unicode: "\u0426",
    horizAdvX: 690,
    d: "M76 0v667h130v-555h264v555h130v-555h80v-262h-120v150h-484z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10041",
    unicode: "\u0427",
    horizAdvX: 620,
    d: "M414 0v266q-68 -7 -119 -7q-121 0 -178 43q-67 50 -67 160v205h130v-182q0 -66 33 -92q29 -22 95 -22q57 0 106 7v289h130v-667h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10042",
    unicode: "\u0428",
    horizAdvX: 970,
    d: "M76 0v667h130v-555h214v555h130v-555h214v555h130v-667h-818z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10043",
    unicode: "\u0429",
    horizAdvX: 984,
    d: "M76 0v667h130v-555h214v555h130v-555h214v555h130v-555h80v-262h-120v150h-778z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10044",
    unicode: "\u042A",
    horizAdvX: 626,
    d: "M146 0v555h-140v112h270v-261h104q104 0 164 -55q62 -57 62 -149q0 -68 -36 -120q-56 -82 -189 -82h-235zM276 294v-182h76q120 0 120 90q0 38 -26.5 65t-91.5 27h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10045",
    unicode: "\u042B",
    horizAdvX: 800,
    d: "M76 0v667h130v-261h104q104 0 164 -55q62 -57 62 -149q0 -68 -36 -120q-56 -82 -189 -82h-235zM206 294v-182h76q120 0 120 90q0 38 -26.5 65t-91.5 27h-78zM594 667h130v-667h-130v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10046",
    unicode: "\u042C",
    horizAdvX: 556,
    d: "M76 0v667h130v-261h104q104 0 164 -55q62 -57 62 -149q0 -68 -36 -120q-56 -82 -189 -82h-235zM206 294v-182h76q120 0 120 90q0 38 -26.5 65t-91.5 27h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10047",
    unicode: "\u042D",
    horizAdvX: 611,
    d: "M44 24v152q72 -73 176 -73q78 0 138.5 46t74.5 130h-299v112h297q-14 82 -73 127.5t-133 45.5q-107 0 -181 -75v152q80 41 174 41q157 0 249 -88q47 -46 73.5 -115.5t26.5 -145.5q0 -159 -99 -255q-93 -93 -249 -93q-94 0 -175 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10048",
    unicode: "\u042E",
    horizAdvX: 1026,
    d: "M206 409h92q17 98 84 171q94 102 256 102q153 0 248.5 -98t95.5 -251q0 -152 -95.5 -250t-248.5 -98q-151 0 -243 89t-101 223h-88v-297h-130v667h130v-258zM638 103q94 0 152 64t58 166q0 112 -63.5 171.5t-146.5 59.5t-146.5 -59.5t-63.5 -171.5q0 -102 58 -166 t152 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10049",
    unicode: "\u042F",
    horizAdvX: 568,
    d: "M492 667v-667h-130v258h-24l-170 -258h-156l198 270q-40 6 -73 30q-75 54 -75 161q0 97 66 155q58 51 171 51h193zM362 561h-40q-16 0 -31 -2t-40 -10.5t-40 -31t-15 -56.5q0 -101 128 -101h38v201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10065",
    unicode: "\u0430",
    horizAdvX: 570,
    d: "M390 377v56h122v-433h-122v56q-49 -70 -133 -70q-98 0 -159.5 67t-61.5 164q0 98 60 164t155 66q94 0 139 -70zM282 339q-52 0 -86 -35t-34 -87t34 -87.5t86 -35.5t86 35.5t34 87.5t-34 87t-86 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10066",
    unicode: "\u0431",
    horizAdvX: 576,
    d: "M404 720h112q-20 -120 -142 -156l-45 -13q-5 -1 -28.5 -7.5t-35 -10.5t-29.5 -13t-30 -21q-44 -41 -49 -111h2q23 30 65 44.5t87 14.5q100 0 162 -61q67 -64 67 -168t-73 -171q-67 -61 -172 -61q-110 0 -173 57q-78 70 -78 219q0 201 66 292q26 36 65 59.5t64 31t66 15.5 q48 10 69.5 23.5t29.5 36.5zM292 94q53 0 87.5 35t34.5 87q0 53 -34 88t-88 35t-88 -35t-34 -88q0 -52 34.5 -87t87.5 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10067",
    unicode: "\u0432",
    horizAdvX: 456,
    d: "M58 433h191q69 0 103 -26q42 -32 42 -85q0 -28 -15.5 -52.5t-44.5 -36.5q32 -6 57 -28q33 -30 33 -81q0 -61 -46 -96q-38 -28 -97 -28h-223v433zM180 261h56q19 0 32 8q16 10 16 30q0 21 -14 31q-10 7 -36 7h-54v-76zM180 96h57q31 0 45 11q16 12 16 35q0 21 -16 31 q-14 10 -42 10h-60v-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10068",
    unicode: "\u0433",
    horizAdvX: 340,
    d: "M58 0v433h276v-104h-154v-329h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10069",
    unicode: "\u0434",
    horizAdvX: 530,
    d: "M98 433h360v-329h64v-230h-110v126h-298v-126h-110v230q51 3 77 55q17 37 17 111v163zM336 104v225h-128v-96q0 -88 -48 -129h176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10070",
    unicode: "\u0435",
    horizAdvX: 522,
    d: "M371 139l112 -18q-7 -18 -18.5 -35.5t-35.5 -43t-65 -41t-94 -15.5q-102 0 -166 61q-68 64 -68 169q0 104 66 170q62 61 163 61q110 0 169 -71q52 -62 52 -170v-10h-324q0 -44 21 -73q30 -41 87 -41q68 0 101 57zM166 274h205q-7 42 -36.5 64.5t-66.5 22.5 q-36 0 -65.5 -23t-36.5 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10072",
    unicode: "\u0436",
    horizAdvX: 668,
    d: "M279 433h110v-168l130 168h142l-165 -197l174 -236h-148l-117 170l-16 -18v-152h-110v152l-16 18l-117 -170h-148l174 236l-165 197h142l130 -168v168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10073",
    unicode: "\u0437",
    horizAdvX: 440,
    d: "M102 317l-56 76q68 54 164 54q73 0 115 -29q49 -33 49 -92q0 -60 -60 -93q32 -8 57 -29q33 -30 33 -80q0 -63 -50 -100q-50 -38 -142 -38q-116 0 -186 72l60 74q49 -46 116 -46q42 0 59 15t17 34q0 24 -23 36q-16 8 -52 8h-51v88h49q33 0 48 10t15 30q0 44 -66 44 q-56 0 -96 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10074",
    unicode: "\u0438",
    horizAdvX: 560,
    d: "M58 433h122v-267l200 267h122v-433h-122v267l-200 -267h-122v433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10075",
    unicode: "\u0439",
    horizAdvX: 560,
    d: "M58 433h122v-267l200 267h122v-433h-122v267l-200 -267h-122v433zM364 650l80 -38q-20 -56 -67 -79.5t-97 -23.5t-97 23.5t-67 79.5l80 38q6 -27 29.5 -45t54.5 -18q29 0 53 16t31 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10076",
    unicode: "\u043A",
    d: "M58 433h122v-168l162 168h152l-196 -193l206 -240h-156l-150 179l-18 -18v-161h-122v433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10077",
    unicode: "\u043B",
    d: "M442 433v-433h-122v329h-118v-159q0 -84 -41 -128q-41 -46 -117 -46q-20 0 -36 4v104q12 -2 19 -2q33 0 50 21q15 18 15 55v255h350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10078",
    unicode: "\u043C",
    horizAdvX: 600,
    d: "M12 0l79 433h90l119 -249l119 249h90l79 -433h-122l-36 235l-108 -235h-44l-108 235l-36 -235h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10079",
    unicode: "\u043D",
    horizAdvX: 530,
    d: "M58 0v433h122v-153h170v153h122v-433h-122v176h-170v-176h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10080",
    unicode: "\u043E",
    horizAdvX: 568,
    d: "M284 447q109 0 175 -61q73 -66 73 -170q0 -103 -73 -169q-66 -61 -175 -61t-175 61q-73 66 -73 169q0 104 73 170q66 61 175 61zM284 94q52 0 87 36t35 86q0 51 -35 87t-87 36t-87 -36t-35 -87q0 -50 35 -86t87 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10081",
    unicode: "\u043F",
    horizAdvX: 526,
    d: "M58 433h410v-433h-122v329h-166v-329h-122v433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10082",
    unicode: "\u0440",
    horizAdvX: 570,
    d: "M180 56v-285h-122v662h122v-56q49 70 141 70q90 0 148 -58q65 -65 65 -172q0 -110 -68 -175q-60 -56 -147 -56t-139 70zM288 339q-47 0 -79 -29q-41 -35 -41 -93q0 -59 40 -94q33 -29 80 -29q49 0 82 31q38 35 38 92q0 56 -37 91q-34 31 -83 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10083",
    unicode: "\u0441",
    horizAdvX: 418,
    d: "M384 421v-120q-41 38 -100 38q-58 0 -90 -35.5t-32 -86.5q0 -53 35.5 -88t90.5 -35q54 0 96 38v-119q-54 -27 -112 -27q-101 0 -167 63q-69 65 -69 166q0 110 75 176q63 56 156 56q63 0 117 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10084",
    unicode: "\u0442",
    horizAdvX: 374,
    d: "M368 329h-120v-329h-122v329h-120v104h362v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10085",
    unicode: "\u0443",
    horizAdvX: 538,
    d: "M49 -229l159 294l-206 368h142l134 -246l120 246h138l-349 -662h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10086",
    unicode: "\u0444",
    horizAdvX: 690,
    d: "M284 -229v223h-10q-92 0 -152 43q-86 60 -86 180q0 118 86 180q60 42 152 42h10v228h122v-228h10q92 0 152 -42q86 -62 86 -180q0 -120 -86 -180q-60 -43 -152 -43h-10v-223h-122zM284 102v229q-45 2 -77 -20q-45 -31 -45 -94q0 -65 44 -94q30 -21 78 -21zM406 331v-229 q48 0 78 21q44 29 44 94q0 63 -45 94q-32 22 -77 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10087",
    unicode: "\u0445",
    horizAdvX: 566,
    d: "M2 0l206 236l-166 197h154l88 -112l90 112h154l-169 -197l205 -236h-156l-124 151l-126 -151h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10088",
    unicode: "\u0446",
    horizAdvX: 542,
    d: "M58 0v433h122v-329h162v329h122v-329h70v-230h-110v126h-366z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10089",
    unicode: "\u0447",
    horizAdvX: 484,
    d: "M304 0v148q-52 -10 -102 -10q-79 0 -121 40q-39 37 -39 102v153h122v-128q0 -33 15 -47q17 -16 62 -16q30 0 63 6v185h122v-433h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10090",
    unicode: "\u0448",
    horizAdvX: 762,
    d: "M58 0v433h122v-329h140v329h122v-329h140v329h122v-433h-646z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10091",
    unicode: "\u0449",
    horizAdvX: 782,
    d: "M58 0v433h122v-329h140v329h122v-329h140v329h122v-329h70v-230h-110v126h-606z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10092",
    unicode: "\u044A",
    horizAdvX: 504,
    d: "M6 433h228v-154h95q76 0 116 -44q33 -35 33 -93q0 -71 -46 -110q-37 -32 -97 -32h-223v329h-106v104zM234 96h57q31 0 45 11q16 12 16 35q0 21 -16 31q-14 10 -42 10h-60v-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10093",
    unicode: "\u044B",
    horizAdvX: 650,
    d: "M58 433h122v-154h95q76 0 116 -44q33 -35 33 -93q0 -71 -46 -110q-37 -32 -97 -32h-223v433zM180 96h57q31 0 45 11q16 12 16 35q0 21 -16 31q-14 10 -42 10h-60v-87zM470 433h122v-433h-122v433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10094",
    unicode: "\u044C",
    horizAdvX: 450,
    d: "M58 433h122v-154h95q76 0 116 -44q33 -35 33 -93q0 -71 -46 -110q-37 -32 -97 -32h-223v433zM180 96h57q31 0 45 11q16 12 16 35q0 21 -16 31q-14 10 -42 10h-60v-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10095",
    unicode: "\u044D",
    horizAdvX: 434,
    d: "M34 9v118q52 -42 126 -42q52 0 80 24q27 24 29 66h-179v88h179q-6 39 -33 61q-30 27 -77 27q-69 0 -123 -37v106q65 27 132 27q108 0 169 -65q61 -63 61 -166q0 -107 -64 -169q-62 -62 -166 -62q-78 0 -134 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10096",
    unicode: "\u044E",
    horizAdvX: 750,
    d: "M180 270h59q11 67 62 116q64 61 169 61q106 0 172 -61q72 -65 72 -170q0 -102 -72 -169q-66 -61 -172 -61q-104 0 -169 61q-51 49 -62 119h-59v-166h-122v433h122v-163zM470 94q51 0 84.5 35.5t33.5 86.5q0 52 -33.5 87.5t-84.5 35.5t-84.5 -35.5t-33.5 -87.5 q0 -51 33.5 -86.5t84.5 -35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10097",
    unicode: "\u044F",
    horizAdvX: 460,
    d: "M20 0l128 162q-42 6 -70 34q-34 34 -34 92q0 67 52 109q46 36 134 36h172v-433h-122v152h-14l-106 -152h-140zM280 240v97h-53q-28 0 -41 -12q-16 -15 -16 -38q0 -24 16 -36q14 -11 41 -11h53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10071",
    unicode: "\u0451",
    horizAdvX: 522,
    d: "M371 139l112 -18q-7 -18 -18.5 -35.5t-35.5 -43t-65 -41t-94 -15.5q-102 0 -166 61q-68 64 -68 169q0 104 66 170q62 61 163 61q110 0 169 -71q52 -62 52 -170v-10h-324q0 -44 21 -73q30 -41 87 -41q68 0 101 57zM166 274h205q-7 42 -36.5 64.5t-66.5 22.5 q-36 0 -65.5 -23t-36.5 -64zM90 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM298 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10099",
    unicode: "\u0452",
    horizAdvX: 544,
    d: "M68 0v519h-78v78h78v132h122v-132h200v-78h-200v-182q50 70 134 70q85 0 128 -53q34 -42 34 -122v-318q0 -82 -49 -117q-38 -27 -106 -27q-38 0 -69 9v108q24 -9 47 -9q33 0 46 22q9 15 9 60v236q0 61 -23 85q-21 22 -57 22q-50 0 -75 -38q-19 -30 -19 -84v-181h-122z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10100",
    unicode: "\u0453",
    horizAdvX: 340,
    d: "M58 0v433h276v-104h-154v-329h-122zM258 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10101",
    unicode: "\u0454",
    horizAdvX: 434,
    d: "M400 124v-118q-47 -20 -116 -20q-113 0 -178 58q-33 30 -51.5 76t-18.5 93q0 101 67 166q68 68 178 68q68 0 117 -30v-106q-52 40 -113 40q-48 0 -82 -29q-31 -25 -41 -62h192v-88h-192q4 -43 40 -66q30 -20 92 -20q65 0 106 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10102",
    unicode: "\u0455",
    horizAdvX: 404,
    d: "M354 401l-60 -71q-31 29 -71 29q-22 0 -34.5 -9.5t-12.5 -25.5q0 -26 39 -39l29 -9q85 -27 110 -62q22 -30 22 -72q0 -66 -48 -110q-50 -46 -130 -46q-101 0 -168 72l64 74q43 -50 96 -50q26 0 43 12.5t17 34.5q0 30 -38 44l-28 10q-65 23 -93 52q-33 35 -33 83 q0 60 45 98q39 31 113 31q78 0 138 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10103",
    unicode: "\u0456",
    horizAdvX: 238,
    d: "M58 433h122v-433h-122v433zM46 616q0 30 21.5 51.5t51.5 21.5t51.5 -21.5t21.5 -51.5t-21.5 -51.5t-51.5 -21.5t-51.5 21.5t-21.5 51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10104",
    unicode: "\u0457",
    horizAdvX: 274,
    d: "M76 433h122v-433h-122v433zM8 617q0 29 17 50.5t41 21.5q22 0 39.5 -20t17.5 -52t-17.5 -52t-39.5 -20q-24 0 -41 21.5t-17 50.5zM151 617q0 32 17.5 52t39.5 20q24 0 41 -21.5t17 -50.5t-17 -50.5t-41 -21.5q-22 0 -39.5 20t-17.5 52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10105",
    unicode: "\u0458",
    horizAdvX: 238,
    d: "M58 433h122v-662h-122v662zM46 616q0 30 21.5 51.5t51.5 21.5t51.5 -21.5t21.5 -51.5t-21.5 -51.5t-51.5 -21.5t-51.5 21.5t-21.5 51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10106",
    unicode: "\u0459",
    horizAdvX: 712,
    d: "M442 433v-154h95q76 0 116 -44q33 -35 33 -93q0 -71 -46 -110q-37 -32 -97 -32h-223v329h-118v-159q0 -84 -41 -128q-41 -46 -117 -46q-20 0 -36 4v104q12 -2 19 -2q33 0 50 21q15 18 15 55v255h350zM442 96h57q31 0 45 11q16 12 16 35q0 21 -16 31q-14 10 -42 10h-60 v-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10107",
    unicode: "\u045A",
    horizAdvX: 742,
    d: "M58 0v433h122v-153h170v153h122v-154h95q76 0 116 -44q33 -35 33 -93q0 -71 -46 -110q-37 -32 -97 -32h-223v176h-170v-176h-122zM472 96h57q31 0 45 11q16 12 16 35q0 21 -16 31q-14 10 -42 10h-60v-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10108",
    unicode: "\u045B",
    horizAdvX: 544,
    d: "M68 0v519h-78v78h78v132h122v-132h200v-78h-200v-182q50 70 134 70q85 0 128 -53q34 -42 34 -122v-232h-122v196q0 61 -23 85q-21 22 -57 22q-50 0 -75 -38q-19 -30 -19 -84v-181h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10109",
    unicode: "\u045C",
    d: "M58 433h122v-168l162 168h152l-196 -193l206 -240h-156l-150 179l-18 -18v-161h-122v433zM318 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10110",
    unicode: "\u045E",
    horizAdvX: 538,
    d: "M49 -229l159 294l-206 368h142l134 -246l120 246h138l-349 -662h-138zM358 650l80 -38q-20 -56 -67 -79.5t-97 -23.5t-97 23.5t-67 79.5l80 38q6 -27 29.5 -45t54.5 -18q29 0 53 16t31 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10193",
    unicode: "\u045F",
    horizAdvX: 522,
    d: "M58 0v433h122v-329h162v329h122v-433h-148v-136h-110v136h-148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10146",
    unicode: "\u0462",
    horizAdvX: 620,
    d: "M140 0v497h-150v100h150v97h130v-97h200v-100h-200v-107h104q104 0 164 -52q62 -54 62 -139q0 -68 -36 -119q-57 -80 -189 -80h-235zM270 290v-184h76q120 0 120 92q0 38 -26.5 65t-91.5 27h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10194",
    unicode: "\u0463",
    horizAdvX: 504,
    d: "M234 271h95q78 0 117 -44q32 -36 32 -89q0 -68 -46 -107q-37 -31 -97 -31h-223v345h-106v88h106v234h122v-234h140v-88h-140v-74zM234 96h57q31 0 45 11q16 12 16 35q0 21 -16 31q-14 10 -42 10h-60v-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10147",
    unicode: "\u0472",
    horizAdvX: 798,
    d: "M399 682q157 0 256 -98t99 -251q0 -152 -99.5 -250t-255.5 -98t-255.5 98t-99.5 250q0 153 99 251t256 98zM618 289h-438q12 -79 71.5 -132.5t147.5 -53.5t147.5 53.5t71.5 132.5zM182 389h434q-16 80 -77 127.5t-140 47.5t-140 -47.5t-77 -127.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10195",
    unicode: "\u0473",
    horizAdvX: 568,
    d: "M284 447q109 0 175 -61q73 -66 73 -170q0 -103 -73 -169q-66 -61 -175 -61t-175 61q-73 66 -73 169q0 104 73 170q66 61 175 61zM406 184h-244q7 -45 42 -73.5t80 -28.5t80 28.5t42 73.5zM166 262h236q-9 41 -43 65t-75 24t-75 -24t-43 -65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10148",
    unicode: "\u0474",
    horizAdvX: 644,
    d: "M2 667h142l178 -448l178 448h142l-282 -667h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10196",
    unicode: "\u0475",
    horizAdvX: 504,
    d: "M2 433h136l114 -244l114 244h136l-218 -433h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10050",
    unicode: "\u0490",
    horizAdvX: 476,
    d: "M76 0v667h274v150h120v-262h-264v-555h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10098",
    unicode: "\u0491",
    horizAdvX: 380,
    d: "M58 0v433h206v126h110v-230h-194v-329h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0492",
    unicode: "\u0492",
    horizAdvX: 436,
    d: "M76 0v308h-96v100h96v259h354v-112h-224v-147h160v-100h-160v-308h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0493",
    unicode: "\u0493",
    horizAdvX: 340,
    d: "M58 0v158h-68v86h68v189h276v-104h-154v-85h100v-86h-100v-158h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0494",
    unicode: "\u0494",
    horizAdvX: 590,
    d: "M426 555h-220v-170q65 23 137 23q85 0 136 -30q91 -52 91 -175q0 -121 -76 -172q-53 -37 -147 -37q-31 0 -67 6v112q33 -6 64 -6q42 0 63 18q29 24 29 74q0 61 -41 84q-25 14 -69 14q-60 0 -120 -23v-273h-130v667h350v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0495",
    unicode: "\u0495",
    horizAdvX: 456,
    d: "M58 0v433h276v-104h-154v-93h18q90 0 141 -33q81 -51 81 -168q0 -95 -67 -163q-69 -69 -173 -80v108q45 6 75 36q39 37 39 97q0 46 -26 72q-27 27 -80 27h-8v-132h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0496",
    unicode: "\u0496",
    horizAdvX: 894,
    d: "M385 667h124v-282l222 282h148l-255 -308l181 -247h83v-262h-120v150h-30l-214 299l-15 -15v-284h-124v284l-15 15l-214 -299h-150l264 359l-255 308h148l222 -282v282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0497",
    unicode: "\u0497",
    horizAdvX: 668,
    d: "M279 433h110v-168l130 168h142l-165 -197l97 -132h75v-230h-110v126h-36l-117 170l-16 -18v-152h-110v152l-16 18l-117 -170h-148l174 236l-165 197h142l130 -168v168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0498",
    unicode: "\u0498",
    horizAdvX: 600,
    d: "M158 515l-68 89q41 36 87 56q54 22 122 22q109 0 170 -61q45 -45 45 -114q0 -49 -22 -87q-20 -35 -60 -53q62 -17 94 -64q30 -43 30 -103q0 -82 -56 -141q-56 -58 -142 -67v-158h-120v155q-59 3 -113 38q-49 31 -85 84l85 81q20 -40 58 -67q45 -32 111 -32q63 0 98 31 q30 27 30 68q0 44 -29 71q-33 31 -117 31h-60v112h60q55 0 84 25q27 23 27 58q0 36 -22 56q-24 23 -77 23q-71 0 -130 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0499",
    unicode: "\u0499",
    horizAdvX: 440,
    d: "M102 317l-56 76q30 23 66 38q44 16 98 16q73 0 115 -29q49 -32 49 -91q0 -39 -21 -64q-15 -18 -39 -30q32 -8 57 -29q33 -31 33 -79q0 -56 -41 -94q-41 -37 -96 -40v-127h-110v128q-76 9 -131 66l60 74q22 -21 50 -32q35 -14 66 -14q35 0 54 12q22 14 22 37q0 25 -23 36 q-16 8 -52 8h-51v88h49q33 0 48 10t15 30q0 22 -19 34q-16 10 -47 10q-24 0 -50 -8q-25 -8 -46 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049A",
    unicode: "\u049A",
    horizAdvX: 636,
    d: "M76 667h130v-282l245 282h164l-282 -308l204 -247h93v-262h-120v150h-52l-237 299l-15 -15v-284h-130v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049B",
    unicode: "\u049B",
    d: "M58 433h122v-168l162 168h152l-196 -193l117 -136h85v-230h-110v126h-42l-150 179l-18 -18v-161h-122v433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049C",
    unicode: "\u049C",
    horizAdvX: 720,
    d: "M76 667h130v-268h69v160h96v-160l190 268h144l-228 -308l237 -359h-152l-191 299v-170h-96v170h-69v-299h-130v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049D",
    unicode: "\u049D",
    horizAdvX: 574,
    d: "M58 433h122v-165h48v100h80v-100l124 165h136l-154 -193l154 -240h-140l-120 190v-120h-80v120h-48v-190h-122v433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A0",
    unicode: "\u04A0",
    horizAdvX: 706,
    d: "M146 0v555h-140v112h270v-282l245 282h164l-282 -308l297 -359h-172l-237 299l-15 -15v-284h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A1",
    unicode: "\u04A1",
    horizAdvX: 584,
    d: "M112 0v329h-106v104h228v-168l162 168h152l-196 -193l206 -240h-156l-150 179l-18 -18v-161h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A2",
    unicode: "\u04A2",
    horizAdvX: 708,
    d: "M76 0v667h130v-258h282v258h130v-555h80v-262h-120v150h-90v297h-282v-297h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A3",
    unicode: "\u04A3",
    horizAdvX: 550,
    d: "M58 0v433h122v-153h170v153h122v-329h70v-230h-110v126h-82v176h-170v-176h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A4",
    unicode: "\u04A4",
    horizAdvX: 848,
    d: "M76 0v667h130v-258h282v258h354v-112h-224v-555h-130v297h-282v-297h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A5",
    unicode: "\u04A5",
    horizAdvX: 632,
    d: "M58 0v433h122v-153h170v153h276v-104h-154v-329h-122v176h-170v-176h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AA",
    unicode: "\u04AA",
    horizAdvX: 604,
    d: "M560 176v-152q-45 -27 -104 -34v-156h-120v155q-113 14 -194 98q-98 101 -98 246q0 160 107 261q94 88 245 88q88 0 164 -41v-152q-65 75 -161 75q-89 0 -148 -57q-73 -70 -73 -176q0 -100 65 -165q63 -63 161 -63q94 0 156 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AB",
    unicode: "\u04AB",
    horizAdvX: 418,
    d: "M384 421v-120q-42 38 -100 38q-51 0 -88 -34q-34 -34 -34 -87q0 -56 37 -91q35 -33 89 -33q53 0 96 38v-119q-24 -14 -59 -22v-127h-110v129q-65 13 -110 56q-69 65 -69 167q0 109 75 175q64 56 160 56q61 0 113 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AE",
    unicode: "\u04AE",
    horizAdvX: 590,
    d: "M227 0v305l-229 362h154l143 -232l143 232h154l-235 -362v-305h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u04AF",
    horizAdvX: 504,
    d: "M2 433h136l114 -244l114 244h136l-189 -376v-286h-122v286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B0",
    unicode: "\u04B0",
    horizAdvX: 590,
    d: "M227 0v205h-180v100h180l-229 362h154l143 -232l143 232h154l-235 -362h180v-100h-180v-205h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B1",
    unicode: "\u04B1",
    horizAdvX: 504,
    d: "M2 433h136l114 -244l114 244h136l-189 -376v-37h140v-96h-140v-153h-122v153h-140v96h140v37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B2",
    unicode: "\u04B2",
    horizAdvX: 640,
    d: "M8 0l236 352l-199 315h156l117 -207l123 207h156l-205 -315l155 -240h73v-262h-120v150h-36l-146 244l-154 -244h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B3",
    unicode: "\u04B3",
    horizAdvX: 564,
    d: "M2 0l206 236l-166 197h154l88 -112l90 112h154l-169 -197l114 -132h89v-230h-110v126h-44l-124 151l-126 -151h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B6",
    unicode: "\u04B6",
    horizAdvX: 634,
    d: "M414 0v266q-68 -7 -119 -7q-121 0 -178 43q-67 50 -67 160v205h130v-182q0 -66 33 -92q29 -22 95 -22q57 0 106 7v289h130v-555h80v-262h-120v150h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B7",
    unicode: "\u04B7",
    horizAdvX: 504,
    d: "M304 0v148q-52 -10 -102 -10q-79 0 -121 40q-39 37 -39 102v153h122v-128q0 -33 15 -47q17 -16 62 -16q30 0 63 6v185h122v-329h70v-230h-110v126h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B8",
    unicode: "\u04B8",
    horizAdvX: 660,
    d: "M454 0v278q-51 -4 -82 -5v-150h-96v150q-102 0 -159 41q-67 48 -67 148v205h130v-182q0 -67 33 -93q25 -19 63 -19v180h96v-180q35 0 82 5v289h130v-667h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B9",
    unicode: "\u04B9",
    horizAdvX: 540,
    d: "M360 0v160q-26 -4 -54 -6v-90h-80v90q-90 0 -139 37q-45 35 -45 103v139h122v-128q0 -33 20 -49q17 -12 42 -14v106h80v-108q27 0 54 8v185h122v-433h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BA",
    unicode: "\u04BA",
    horizAdvX: 620,
    d: "M206 667v-246q68 7 119 7q121 0 178 -43q67 -50 67 -160v-225h-130v202q0 66 -33 92q-29 22 -95 22q-57 0 -106 -7v-309h-130v667h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BB",
    unicode: "\u04BB",
    horizAdvX: 534,
    d: "M58 0v729h122v-352q50 70 134 70q85 0 128 -53q34 -42 34 -122v-272h-122v236q0 61 -23 85q-21 22 -57 22q-50 0 -75 -38q-19 -30 -19 -84v-221h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C0",
    unicode: "\u04C0",
    horizAdvX: 282,
    d: "M76 667h130v-667h-130v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C1",
    unicode: "\u04C1",
    horizAdvX: 894,
    d: "M385 667h124v-282l222 282h148l-255 -308l264 -359h-150l-214 299l-15 -15v-284h-124v284l-15 15l-214 -299h-150l264 359l-255 308h148l222 -282v282zM267 844l90 36q22 -58 90 -58t90 58l90 -36q-20 -52 -66.5 -82t-113.5 -30t-113.5 30t-66.5 82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C2",
    unicode: "\u04C2",
    horizAdvX: 668,
    d: "M279 433h110v-168l130 168h142l-165 -197l174 -236h-148l-117 170l-16 -18v-152h-110v152l-16 18l-117 -170h-148l174 236l-165 197h142l130 -168v168zM418 650l80 -38q-20 -56 -67 -79.5t-97 -23.5t-97 23.5t-67 79.5l80 38q6 -27 29.5 -45t54.5 -18q29 0 53 16t31 47z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C3",
    unicode: "\u04C3",
    horizAdvX: 620,
    d: "M76 667h130v-282l245 282h164l-243 -264q106 0 164 -58q54 -55 54 -151q0 -94 -57 -152q-52 -53 -141 -53q-68 0 -128 30l34 103q35 -21 75 -21q37 0 59 22q24 24 24 65q0 49 -27 76q-32 32 -108 32q-52 0 -115 -7v-289h-130v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C4",
    unicode: "\u04C4",
    horizAdvX: 480,
    d: "M58 433h122v-181l148 181h152l-189 -203q60 -11 98 -47q56 -53 56 -148q0 -96 -67 -163q-69 -69 -173 -80v108q43 6 75 36q39 38 39 106q0 49 -29 75q-29 25 -84 25h-26v-142h-122v433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C7",
    unicode: "\u04C7",
    horizAdvX: 694,
    d: "M76 0v667h130v-258h282v258h130v-753q0 -69 -36 -106q-37 -38 -111 -38q-46 0 -85 9v112q23 -9 46 -9q27 0 41 14q15 16 15 68v333h-282v-297h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C8",
    unicode: "\u04C8",
    horizAdvX: 530,
    d: "M58 0v433h122v-153h170v153h122v-519q0 -82 -49 -117q-38 -27 -106 -27q-38 0 -69 9v108q24 -9 47 -9q33 0 46 22q9 15 9 60v216h-170v-176h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D0",
    unicode: "\u04D0",
    horizAdvX: 672,
    d: "M530 0l-59 140h-269l-59 -140h-141l287 667h102l279 -667h-140zM243 246h190l-95 240zM156 844l90 36q22 -58 90 -58t90 58l90 -36q-20 -52 -66.5 -82t-113.5 -30t-113.5 30t-66.5 82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D1",
    unicode: "\u04D1",
    horizAdvX: 570,
    d: "M390 377v56h122v-433h-122v56q-49 -70 -133 -70q-98 0 -159.5 67t-61.5 164q0 98 60 164t155 66q94 0 139 -70zM282 339q-52 0 -86 -35t-34 -87t34 -87.5t86 -35.5t86 35.5t34 87.5t-34 87t-86 35zM369 650l80 -38q-20 -56 -67 -79.5t-97 -23.5t-97 23.5t-67 79.5l80 38 q6 -27 29.5 -45t54.5 -18q29 0 53 16t31 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D2",
    unicode: "\u04D2",
    horizAdvX: 672,
    d: "M530 0l-59 140h-269l-59 -140h-141l287 667h102l279 -667h-140zM243 246h190l-95 240zM152 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM376 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5 t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D3",
    unicode: "\u04D3",
    horizAdvX: 570,
    d: "M390 377v56h122v-433h-122v56q-49 -70 -133 -70q-98 0 -159.5 67t-61.5 164q0 98 60 164t155 66q94 0 139 -70zM282 339q-52 0 -86 -35t-34 -87t34 -87.5t86 -35.5t86 35.5t34 87.5t-34 87t-86 35zM109 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5 t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM317 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D4",
    unicode: "\u04D4",
    horizAdvX: 920,
    d: "M533 0l-59 140h-269l-59 -140h-140l289 667h352l44 -112h-245l60 -149h241l46 -112h-242l73 -182h246l44 -112h-381zM246 246h190l-92 240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D5",
    unicode: "\u04D5",
    horizAdvX: 808,
    d: "M657 139l112 -18q-18 -46 -49.5 -76t-66.5 -41t-56 -14.5t-41 -3.5q-113 0 -168 82q-62 -82 -174 -82q-85 0 -131.5 40.5t-46.5 99.5q0 61 44 100q51 45 139 45q59 0 112 -30l1 21q3 45 -37 71q-28 18 -81 18q-52 0 -111 -17v97q71 16 120 16q33 0 57.5 -3.5t56 -20.5 t51.5 -49q58 73 164 73q109 0 168 -71q52 -62 52 -170v-10h-324q-2 -43 21 -73q30 -41 87 -41q68 0 101 57zM154 131q0 -22 21 -40.5t64 -18.5q46 0 69 19.5t23 41.5q0 20 -22 36t-71 16q-44 0 -64 -16.5t-20 -37.5zM452 274h205q-7 42 -36.5 64.5t-66.5 22.5 q-36 0 -65.5 -23t-36.5 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D6",
    unicode: "\u04D6",
    horizAdvX: 496,
    d: "M446 667v-112h-240v-149h230v-112h-230v-182h240v-112h-370v667h370zM80 844l90 36q22 -58 90 -58t90 58l90 -36q-20 -52 -66.5 -82t-113.5 -30t-113.5 30t-66.5 82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D7",
    unicode: "\u04D7",
    horizAdvX: 522,
    d: "M371 139l112 -18q-7 -18 -18.5 -35.5t-35.5 -43t-65 -41t-94 -15.5q-102 0 -166 61q-68 64 -68 169q0 104 66 170q62 61 163 61q110 0 169 -71q52 -62 52 -170v-10h-324q0 -44 21 -73q30 -41 87 -41q68 0 101 57zM166 274h205q-7 42 -36.5 64.5t-66.5 22.5 q-36 0 -65.5 -23t-36.5 -64zM350 650l80 -38q-20 -56 -67 -79.5t-97 -23.5t-97 23.5t-67 79.5l80 38q6 -27 29.5 -45t54.5 -18q29 0 53 16t31 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D8",
    unicode: "\u04D8",
    horizAdvX: 762,
    d: "M44 377h538q-12 82 -71 134.5t-140 52.5q-111 0 -178 -90l-113 61q55 72 131.5 109.5t162.5 37.5q151 0 247.5 -97t96.5 -252t-96 -251.5t-247 -96.5q-174 0 -263 130q-68 98 -68 225v37zM581 277h-390q4 -64 42 -110q54 -64 144 -64q85 0 143 57q47 47 61 117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10846",
    unicode: "\u04D9",
    horizAdvX: 522,
    d: "M159 298l-112 18q55 131 209 131q98 0 162 -61q68 -65 68 -169t-66 -170q-62 -61 -163 -61q-110 0 -169 71q-52 62 -52 170v20h324q-1 37 -21 63q-29 41 -83 41q-67 0 -97 -53zM358 169h-209q7 -46 36 -71.5t69 -25.5t69 26t35 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DA",
    unicode: "\u04DA",
    horizAdvX: 762,
    d: "M44 377h538q-12 82 -71 134.5t-140 52.5q-111 0 -178 -90l-113 61q55 72 131.5 109.5t162.5 37.5q151 0 247.5 -97t96.5 -252t-96 -251.5t-247 -96.5q-174 0 -263 130q-68 98 -68 225v37zM581 277h-390q4 -64 42 -110q54 -64 144 -64q85 0 143 57q47 47 61 117zM198 811 q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM422 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DB",
    unicode: "\u04DB",
    horizAdvX: 522,
    d: "M159 298l-112 18q55 131 209 131q98 0 162 -61q68 -65 68 -169t-66 -170q-62 -61 -163 -61q-110 0 -169 71q-52 62 -52 170v20h324q-1 37 -21 63q-29 41 -83 41q-67 0 -97 -53zM358 169h-209q7 -46 36 -71.5t69 -25.5t69 26t35 71zM84 586q0 29 21.5 50.5t50.5 21.5 t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM292 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DC",
    unicode: "\u04DC",
    horizAdvX: 894,
    d: "M385 667h124v-282l222 282h148l-255 -308l264 -359h-150l-214 299l-15 -15v-284h-124v284l-15 15l-214 -299h-150l264 359l-255 308h148l222 -282v282zM263 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM487 811 q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DD",
    unicode: "\u04DD",
    horizAdvX: 668,
    d: "M279 433h110v-168l130 168h142l-165 -197l174 -236h-148l-117 170l-16 -18v-152h-110v152l-16 18l-117 -170h-148l174 236l-165 197h142l130 -168v168zM158 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM366 586 q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DE",
    unicode: "\u04DE",
    horizAdvX: 600,
    d: "M158 515l-68 89q87 78 205 78q101 0 160 -47.5t59 -126.5q0 -95 -82 -141q60 -15 92 -62t32 -110q0 -94 -74 -152t-191 -58q-173 0 -251 126l85 81q22 -50 69.5 -74.5t99.5 -24.5q63 0 95.5 29t32.5 70q0 102 -146 102h-60v112h60q51 0 81 22.5t30 62.5q0 37 -24 57 t-71 20q-86 0 -134 -53zM116 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM340 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DF",
    unicode: "\u04DF",
    horizAdvX: 440,
    d: "M102 317l-56 76q68 54 164 54q73 0 115 -29q49 -33 49 -92q0 -60 -60 -93q32 -8 57 -29q33 -30 33 -80q0 -63 -50 -100q-50 -38 -142 -38q-116 0 -186 72l60 74q49 -46 116 -46q42 0 59 15t17 34q0 24 -23 36q-16 8 -52 8h-51v88h49q33 0 48 10t15 30q0 44 -66 44 q-56 0 -96 -34zM38 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM246 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E2",
    unicode: "\u04E2",
    horizAdvX: 740,
    d: "M76 667h130v-444l366 444h92v-667h-130v446l-366 -446h-92v667zM197 745v86h366v-86h-366z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E3",
    unicode: "\u04E3",
    horizAdvX: 560,
    d: "M58 433h122v-267l200 267h122v-433h-122v267l-200 -267h-122v433zM98 539v80h364v-80h-364z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E4",
    unicode: "\u04E4",
    horizAdvX: 740,
    d: "M76 667h130v-444l366 444h92v-667h-130v446l-366 -446h-92v667zM196 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM420 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5 t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E5",
    unicode: "\u04E5",
    horizAdvX: 560,
    d: "M58 433h122v-267l200 267h122v-433h-122v267l-200 -267h-122v433zM104 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM312 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5 t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E6",
    unicode: "\u04E6",
    horizAdvX: 800,
    d: "M400 682q157 0 256.5 -98t99.5 -251t-99.5 -250.5t-256.5 -97.5t-256.5 97.5t-99.5 250.5t99.5 251t256.5 98zM400 103q98 0 160 64.5t62 165.5t-62.5 166t-159.5 65t-159.5 -65t-62.5 -166t62 -165.5t160 -64.5zM216 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5 t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM440 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E7",
    unicode: "\u04E7",
    horizAdvX: 568,
    d: "M284 447q109 0 175 -61q73 -66 73 -170q0 -103 -73 -169q-66 -61 -175 -61t-175 61q-73 66 -73 169q0 104 73 170q66 61 175 61zM284 94q52 0 87 36t35 86q0 51 -35 87t-87 36t-87 -36t-35 -87q0 -50 35 -86t87 -36zM108 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5 t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM316 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E8",
    unicode: "\u04E8",
    horizAdvX: 798,
    d: "M399 682q157 0 256 -98t99 -251q0 -152 -99.5 -250t-255.5 -98t-255.5 98t-99.5 250q0 153 99 251t256 98zM618 289h-438q12 -79 71.5 -132.5t147.5 -53.5t147.5 53.5t71.5 132.5zM182 389h434q-16 80 -77 127.5t-140 47.5t-140 -47.5t-77 -127.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E9",
    unicode: "\u04E9",
    horizAdvX: 568,
    d: "M284 447q109 0 175 -61q73 -66 73 -170q0 -103 -73 -169q-66 -61 -175 -61t-175 61q-73 66 -73 169q0 104 73 170q66 61 175 61zM406 184h-244q7 -45 42 -73.5t80 -28.5t80 28.5t42 73.5zM166 262h236q-9 41 -43 65t-75 24t-75 -24t-43 -65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EA",
    unicode: "\u04EA",
    horizAdvX: 798,
    d: "M399 682q157 0 256 -98t99 -251q0 -152 -99.5 -250t-255.5 -98t-255.5 98t-99.5 250q0 153 99 251t256 98zM618 289h-438q12 -79 71.5 -132.5t147.5 -53.5t147.5 53.5t71.5 132.5zM182 389h434q-16 80 -77 127.5t-140 47.5t-140 -47.5t-77 -127.5zM216 811 q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM440 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EB",
    unicode: "\u04EB",
    horizAdvX: 568,
    d: "M284 447q109 0 175 -61q73 -66 73 -170q0 -103 -73 -169q-66 -61 -175 -61t-175 61q-73 66 -73 169q0 104 73 170q66 61 175 61zM406 184h-244q7 -45 42 -73.5t80 -28.5t80 28.5t42 73.5zM166 262h236q-9 41 -43 65t-75 24t-75 -24t-43 -65zM108 586q0 29 21.5 50.5 t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM316 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EE",
    unicode: "\u04EE",
    horizAdvX: 610,
    d: "M2 667h152l169 -336l143 336h142l-309 -667h-142l93 186zM127 745v86h366v-86h-366z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EF",
    unicode: "\u04EF",
    horizAdvX: 538,
    d: "M49 -229l159 294l-206 368h142l134 -246l120 246h138l-349 -662h-138zM87 539v80h364v-80h-364z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F0",
    unicode: "\u04F0",
    horizAdvX: 610,
    d: "M2 667h152l169 -336l143 336h142l-309 -667h-142l93 186zM136 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM360 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5 t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F1",
    unicode: "\u04F1",
    horizAdvX: 538,
    d: "M49 -229l159 294l-206 368h142l134 -246l120 246h138l-349 -662h-138zM93 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM301 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5 t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F2",
    unicode: "\u04F2",
    horizAdvX: 610,
    d: "M2 667h152l169 -336l143 336h142l-309 -667h-142l93 186zM268 921l90 -59l-144 -134l-56 40zM468 920l90 -58l-144 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F3",
    unicode: "\u04F3",
    horizAdvX: 538,
    d: "M49 -229l159 294l-206 368h142l134 -246l120 246h138l-349 -662h-138zM223 690l82 -58l-132 -134l-50 40zM411 689l82 -57l-132 -134l-50 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F4",
    unicode: "\u04F4",
    horizAdvX: 620,
    d: "M414 0v266q-68 -7 -119 -7q-121 0 -178 43q-67 50 -67 160v205h130v-182q0 -66 33 -92q29 -22 95 -22q57 0 106 7v289h130v-667h-130zM120 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM344 811q0 29 21.5 50.5 t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F5",
    unicode: "\u04F5",
    horizAdvX: 484,
    d: "M304 0v148q-52 -10 -102 -10q-79 0 -121 40q-39 37 -39 102v153h122v-128q0 -33 15 -47q17 -16 62 -16q30 0 63 6v185h122v-433h-122zM60 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM268 586q0 29 21.5 50.5 t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F8",
    unicode: "\u04F8",
    horizAdvX: 800,
    d: "M76 0v667h130v-261h104q104 0 164 -55q62 -57 62 -149q0 -68 -36 -120q-56 -82 -189 -82h-235zM206 294v-182h76q120 0 120 90q0 38 -26.5 65t-91.5 27h-78zM594 667h130v-667h-130v667zM216 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5 t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM440 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F9",
    unicode: "\u04F9",
    horizAdvX: 650,
    d: "M58 433h122v-154h95q76 0 116 -44q33 -35 33 -93q0 -71 -46 -110q-37 -32 -97 -32h-223v433zM180 96h57q31 0 45 11q16 12 16 35q0 21 -16 31q-14 10 -42 10h-60v-87zM470 433h122v-433h-122v433zM149 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5 t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM357 586q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2010",
    unicode: "\u2010",
    horizAdvX: 360,
    d: "M50 174v112h260v-112h-260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2011",
    unicode: "\u2011",
    horizAdvX: 360,
    d: "M50 174v112h260v-112h-260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "figuredash",
    unicode: "\u2012",
    horizAdvX: 640,
    d: "M70 289v104h500v-104h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 640,
    d: "M70 178v104h500v-104h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 840,
    d: "M70 178v104h700v-104h-700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii00208",
    unicode: "\u2015",
    horizAdvX: 840,
    d: "M70 178v104h700v-104h-700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 304,
    d: "M260 667l-106 -269l-112 13l141 265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 304,
    d: "M42 411l106 269l112 -13l-141 -265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 370,
    d: "M42 -131l106 269l112 -13l-141 -265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 492,
    d: "M448 667l-106 -269l-112 13l141 265zM260 667l-106 -269l-112 13l141 265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 492,
    d: "M42 411l106 269l112 -13l-141 -265zM230 411l106 269l112 -13l-141 -265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 570,
    d: "M42 -131l106 269l112 -13l-141 -265zM230 -131l106 269l112 -13l-141 -265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 568,
    d: "M226 521v208h116v-208h158v-104h-158v-597h-116v597h-158v104h158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 568,
    d: "M226 521v208h116v-208h158v-104h-158v-241h158v-104h-158v-252h-116v252h-158v104h158v241h-158v104h158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 1000,
    d: "M360 340q0 58 41 99t99 41t99 -41t41 -99t-41 -99t-99 -41t-99 41t-41 99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 846,
    d: "M63 65q0 33 22.5 55.5t55.5 22.5t55.5 -22.5t22.5 -55.5t-22.5 -55.5t-55.5 -22.5t-55.5 22.5t-22.5 55.5zM345 65q0 33 22.5 55.5t55.5 22.5t55.5 -22.5t22.5 -55.5t-22.5 -55.5t-55.5 -22.5t-55.5 22.5t-22.5 55.5zM627 65q0 33 22.5 55.5t55.5 22.5t55.5 -22.5 t22.5 -55.5t-22.5 -55.5t-55.5 -22.5t-55.5 22.5t-22.5 55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1170,
    d: "M198 675q77 0 122.5 -44.5t45.5 -113.5t-45.5 -113.5t-122.5 -44.5t-122.5 44.5t-45.5 113.5t45.5 113.5t122.5 44.5zM198 431q37 0 60.5 24t23.5 62t-23.5 62t-60.5 24t-60.5 -24t-23.5 -62t23.5 -62t60.5 -24zM162 3l397 686l53 -30l-397 -687zM576 306 q77 0 122.5 -44.5t45.5 -113.5t-45.5 -113.5t-122.5 -44.5t-122.5 44.5t-45.5 113.5t45.5 113.5t122.5 44.5zM576 62q37 0 60.5 24t23.5 62t-23.5 62t-60.5 24t-60.5 -24t-23.5 -62t23.5 -62t60.5 -24zM972 306q77 0 122.5 -44.5t45.5 -113.5t-45.5 -113.5t-122.5 -44.5 t-122.5 44.5t-45.5 113.5t45.5 113.5t122.5 44.5zM972 62q37 0 60.5 24t23.5 62t-23.5 62t-60.5 24t-60.5 -24t-23.5 -62t23.5 -62t60.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 318,
    d: "M146 219l122 -164l-70 -50l-158 214l158 214l70 -50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 318,
    d: "M172 219l-122 164l70 50l158 -214l-158 -214l-70 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 250,
    d: "M-100 3l397 686l53 -30l-397 -687z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2080",
    unicode: "\u2080",
    horizAdvX: 380,
    d: "M190 -9q-66 0 -114 55t-48 154t48 154t114 55t114 -55t48 -154t-48 -154t-114 -55zM190 337q-31 0 -54.5 -33.5t-23.5 -103.5q0 -76 25.5 -106.5t52.5 -30.5t52.5 30.5t25.5 106.5q0 70 -23.5 103.5t-54.5 33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2081",
    unicode: "\u2081",
    horizAdvX: 380,
    d: "M166 0v328h-80v72h164v-400h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2082",
    unicode: "\u2082",
    horizAdvX: 380,
    d: "M24 0l119 134q64 74 71 84q23 33 23 64q0 25 -15 40t-42 15q-30 0 -47 -17.5t-17 -44.5h-84q2 61 42 97.5t102 36.5q66 0 105.5 -36.5t39.5 -90.5q0 -39 -18.5 -70.5t-52.5 -69.5l-62 -70h136v-72h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2083",
    unicode: "\u2083",
    horizAdvX: 380,
    d: "M123 291h-78q6 57 42.5 87.5t92.5 30.5q65 0 98 -32t33 -76q0 -60 -50 -86q65 -22 65 -96q0 -54 -38.5 -91t-109.5 -37q-61 0 -103 34.5t-47 94.5h84q3 -26 20.5 -41.5t45.5 -15.5q32 0 48 17.5t16 42.5q0 22 -16 38.5t-50 16.5h-20v66h20q27 0 41 15t14 36 q0 19 -13.5 33.5t-39.5 14.5q-24 0 -39 -14.5t-16 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2084",
    unicode: "\u2084",
    horizAdvX: 380,
    d: "M303 407v-268h47v-68h-47v-71h-80v71h-199v35l199 301h80zM124 139h99v153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2085",
    unicode: "\u2085",
    horizAdvX: 380,
    d: "M306 400v-72h-135l-13 -58q16 2 27 2q67 0 103 -39t36 -96q0 -62 -41.5 -104t-121.5 -42q-77 0 -129 51l26 72q42 -51 101 -51q39 0 60 22t21 51q0 31 -23.5 52.5t-67.5 21.5q-43 0 -77 -26h-5l48 216h191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2086",
    unicode: "\u2086",
    horizAdvX: 380,
    d: "M204 422l62 -47l-95 -121q23 9 47 9q53 0 91.5 -34.5t38.5 -95.5q0 -59 -40.5 -100.5t-117.5 -41.5q-74 0 -116 40t-42 98t49 125zM190 57q31 0 52.5 20t21.5 50t-21.5 50t-52.5 20t-52.5 -20t-21.5 -50t21.5 -50t52.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2087",
    unicode: "\u2087",
    horizAdvX: 380,
    d: "M56 26l181 302h-203v72h336l-243 -411z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2088",
    unicode: "\u2088",
    horizAdvX: 380,
    d: "M116 209q-57 25 -57 89q0 47 34.5 79t96.5 32t96.5 -32t34.5 -79q0 -64 -57 -89q36 -12 53.5 -40t17.5 -60q0 -51 -40 -84.5t-105 -33.5t-105 33.5t-40 84.5q0 32 17.5 60t53.5 40zM190 343q-21 0 -38.5 -13.5t-17.5 -38.5t17.5 -38.5t38.5 -13.5t38.5 13.5t17.5 38.5 t-17.5 38.5t-38.5 13.5zM190 173q-26 0 -43.5 -17t-17.5 -41q0 -25 17.5 -41.5t43.5 -16.5t43.5 16.5t17.5 41.5q0 24 -17.5 41t-43.5 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2089",
    unicode: "\u2089",
    horizAdvX: 380,
    d: "M176 -22l-62 47l95 121q-23 -9 -47 -9q-53 0 -91.5 34.5t-38.5 95.5q0 59 40.5 100.5t117.5 41.5q74 0 116 -40t42 -98q0 -62 -47 -125zM190 343q-31 0 -52.5 -20t-21.5 -50t21.5 -50t52.5 -20t52.5 20t21.5 50t-21.5 50t-52.5 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 568,
    d: "M534 172v-146q-76 -41 -184 -41q-150 0 -230 87q-54 58 -65 139h-75l36 90h30q-4 33 0 63h-66l36 90h42q19 85 80 143q88 85 233 85q97 0 173 -44l-51 -109q-55 35 -130 35q-42 0 -74 -11.5t-50 -30.5t-27.5 -35t-14.5 -33h268l-36 -90h-249q-4 -36 0 -63h231l-36 -90 h-176q13 -55 59.5 -81.5t105.5 -26.5q107 0 170 69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4",
    unicode: "\u20B4",
    horizAdvX: 568,
    d: "M143 515l-68 89q37 31 83 52q60 26 127 26q97 0 146 -46q44 -43 44 -102q0 -43 -26 -80h70v-90h-142l-65 -63h207v-90h-277q-18 -21 -18 -48q0 -29 24 -46q20 -14 53 -14q43 0 78 24q29 20 50 53l80 -88q-36 -45 -90 -75q-61 -32 -140 -32q-84 0 -132 41q-50 42 -50 104 q0 47 21 81h-74v90h138l65 63h-203v90h276q24 23 24 53q0 31 -22 49q-21 17 -52 17q-41 0 -80 -23q-27 -15 -47 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B6",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CF",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CE",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CD",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CC",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CB",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CA",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C9",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C8",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C7",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C6",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C5",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C4",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C3",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C2",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C1",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C0",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BF",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BE",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BD",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BC",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BB",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BA",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B9",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B7",
    horizAdvX: 568,
    d: "M295 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM231 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8",
    unicode: "\u20B8",
    horizAdvX: 568,
    d: "M499 418h-150v-418h-130v418h-150v112h430v-112zM499 575h-430v92h430v-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1080,
    d: "M206 0h-130v667h130l306 -449v449h130v-667h-130l-306 449v-449zM870 667q77 0 122.5 -44.5t45.5 -113.5t-45.5 -113.5t-122.5 -44.5t-122.5 44.5t-45.5 113.5t45.5 113.5t122.5 44.5zM870 595q-37 0 -60.5 -24t-23.5 -62t23.5 -62t60.5 -24t60.5 24t23.5 62t-23.5 62 t-60.5 24zM722 197v86h296v-86h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2117",
    unicode: "\u2117",
    horizAdvX: 760,
    d: "M380 682q145 0 245 -99q102 -102 102 -251q0 -143 -94 -242q-99 -105 -253 -105q-149 0 -249 101q-98 98 -98 248q0 155 107 255q97 93 240 93zM380 620q-113 0 -192 -80q-85 -85 -85 -205q0 -62 23 -117t59 -91t88 -58t107 -22q110 0 191 79q86 83 86 205q0 124 -86 210 q-79 79 -191 79zM263 527h121q62 0 94 -32q30 -30 30 -84q0 -53 -27 -83q-30 -32 -101 -32h-41v-143h-76v374zM339 461v-103h30q31 0 46 15q14 14 14 38q0 26 -14 38q-13 12 -43 12h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 720,
    d: "M247 591h-82v-304h-85v304h-82v76h249v-76zM345 287h-85l68 387h62l93 -231l98 231h62l61 -387h-85l-29 209l-90 -214h-34l-88 214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 546,
    d: "M84 568l16 105q87 -5 169 -38.5t137 -87.5q104 -103 104 -272q0 -155 -82 -232q-62 -57 -158 -57q-101 0 -167 64q-67 64 -67 165q0 99 65 162q58 56 143 56q74 0 125 -50q-27 88 -116 137q-72 40 -169 48zM270 329q-44 0 -74 -30q-34 -34 -34 -89t34 -87q31 -29 74 -29 q48 0 79 34q29 33 29 82q0 24 -10.5 50.5t-26.5 42.5q-27 26 -71 26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 730,
    d: "M40 638v112h650v-112h-82v-776h82v-112h-284v112h80v776h-242v-776h80v-112h-284v112h82v776h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 668,
    d: "M22 750h595v-244h-112l-10 132h-333l248 -371l-248 -405h342l10 135h112v-247h-604v122l244 395l-244 361v122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    d: "M33 283v112h434v-112h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 653,
    d: "M-20 -170l525 929l88 -40l-525 -929z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 200,
    d: "M8 286q0 38 27 65t65 27t65 -27t27 -65t-27 -65t-65 -27t-65 27t-27 65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 668,
    d: "M381 827h287v-110h-181l-173 -717h-160l-60 274h-94v110h194l21 -91q8 -37 10 -71l5 -61v-12h11q13 142 49 297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 668,
    d: "M337 260q-66 -82 -159 -82q-70 0 -115.5 45t-45.5 116t45 116.5t114 45.5q92 0 156 -82q67 82 157 82q71 0 116.5 -45t45.5 -116t-45.5 -116.5t-114.5 -45.5q-94 0 -154 82zM470 392q-43 0 -76 -53q35 -52 76 -52q26 0 40.5 16t14.5 37q0 23 -16.5 37.5t-38.5 14.5z M198 287q22 0 42.5 15.5t33.5 36.5q-30 53 -76 53q-26 0 -40.5 -16t-14.5 -37q0 -22 16 -37t39 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    d: "M53 -240l23 109q29 -10 51 -10q30 0 44 15q17 18 17 73v606q0 92 34 139q42 58 139 58q39 0 86 -10l-23 -109q-29 10 -51 10q-30 0 -44 -15q-17 -18 -17 -73v-606q0 -92 -34 -139q-42 -58 -139 -58q-39 0 -86 10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    d: "M424 523l70 -40q-37 -88 -92 -116q-30 -15 -59 -15q-35 0 -106 27q-67 25 -90 25q-20 0 -37 -14t-23.5 -26t-10.5 -23l-70 40q30 86 77 119q28 21 71 21q35 0 108 -27q71 -25 88 -25q46 0 74 54zM424 325l70 -40q-37 -88 -92 -116q-30 -15 -59 -15q-35 0 -106 27 q-67 25 -90 25q-20 0 -37 -14t-23.5 -26t-10.5 -23l-70 40q30 86 77 119q28 21 71 21q35 0 108 -27q71 -25 88 -25q46 0 74 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    d: "M33 374v106h237l49 104h96l-49 -104h101v-106h-151l-33 -70h184v-106h-234l-52 -110h-96l52 110h-104v106h154l33 70h-187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    d: "M153 393l314 -134v-114l-434 197v102l434 209v-114zM33 118h434v-110h-434v110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    d: "M347 393l-314 146v114l434 -209v-102l-434 -197v114zM467 118v-110h-434v110h434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotmath",
    unicode: "\u22C5",
    horizAdvX: 200,
    d: "M8 286q0 38 27 65t65 27t65 -27t27 -65t-27 -65t-65 -27t-65 27t-27 65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 700,
    d: "M90 334l260 360l260 -360l-260 -360zM468 334l-118 162l-118 -162l118 -162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "openbullet",
    unicode: "\u25E6",
    d: "M250 662q65 0 109 -42.5t44 -107.5t-44 -107.5t-109 -42.5t-109 42.5t-44 107.5t44 107.5t109 42.5zM250 590q-35 0 -57 -22t-22 -56t22 -56t57 -22t57 22t22 56t-22 56t-57 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF400",
    unicode: "\uF400",
    horizAdvX: 2,
    d: "M-180 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF401",
    unicode: "\uF401",
    horizAdvX: 2,
    d: "M-312 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF406",
    unicode: "\uF406",
    d: "M330 870h90q-6 -63 -53 -103.5t-117 -40.5t-117 40.5t-53 103.5h90q12 -60 80 -60t80 60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF407",
    unicode: "\uF407",
    d: "M254 -46l96 -44l-122 -154l-66 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF408",
    unicode: "\uF408",
    d: "M250 820l-120 -88l-60 64l180 134l180 -134l-60 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF409",
    unicode: "\uF409",
    d: "M160 -258l68 208l112 -16l-100 -204z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40A",
    unicode: "\uF40A",
    d: "M160 468l66 212l114 -20l-96 -208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40B",
    unicode: "\uF40B",
    d: "M172 817q0 33 22.5 55.5t55.5 22.5t55.5 -22.5t22.5 -55.5t-22.5 -55.5t-55.5 -22.5t-55.5 22.5t-22.5 55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40C",
    unicode: "\uF40C",
    d: "M210 826q0 -17 11.5 -28.5t28.5 -11.5t28.5 11.5t11.5 28.5t-11.5 28.5t-28.5 11.5t-28.5 -11.5t-11.5 -28.5zM151 826q0 42 28.5 70.5t70.5 28.5t70.5 -28.5t28.5 -70.5t-28.5 -70.5t-70.5 -28.5t-70.5 28.5t-28.5 70.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40D",
    unicode: "\uF40D",
    d: "M377 869l65 -48q-18 -37 -45 -59q-31 -28 -69 -28q-26 0 -68 17l-35 14q-40 15 -50 15q-19 0 -34 -15q-10 -10 -16 -24l-67 48q17 32 39 54q33 33 76 33q24 0 68 -17l39 -16q31 -13 48 -13q20 0 33 13q8 8 16 26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40E",
    unicode: "\uF40E",
    d: "M274 0h66q-24 -16 -36 -30q-20 -22 -20 -43q0 -18 11.5 -30.5t33.5 -12.5q21 0 47 12l-14 -69q-28 -17 -67 -17q-45 0 -70 25t-25 60q0 34 26 65q21 24 48 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4C6",
    unicode: "\uF4C6",
    horizAdvX: 620,
    d: "M180 667v-182q0 -66 33 -92q29 -22 95 -22q57 0 106 7v289h130v-750q0 -71 -36 -108q-37 -38 -111 -38q-46 0 -85 9v112q24 -9 46 -9q27 0 41 14q15 16 15 68v301q-68 -7 -119 -7q-121 0 -178 43q-67 50 -67 160v205h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4C7",
    unicode: "\uF4C7",
    horizAdvX: 484,
    d: "M42 433h122v-128q0 -33 15 -47q17 -16 62 -16q30 0 63 6v185h122v-519q0 -82 -49 -117q-38 -27 -106 -27q-38 0 -69 9v108q24 -9 47 -9q33 0 46 22q9 15 9 60v188q-52 -10 -102 -10q-79 0 -121 40q-39 37 -39 102v153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4CC",
    unicode: "\uF4CC",
    horizAdvX: 610,
    d: "M2 667h152l169 -336l143 336h142l-309 -667h-142l93 186zM281 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4CD",
    unicode: "\uF4CD",
    horizAdvX: 538,
    d: "M49 -229l159 294l-206 368h142l134 -246l120 246h138l-349 -662h-138zM337 700l88 -56l-150 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar.fitted",
    unicode: "\uF5F5",
    horizAdvX: 483,
    d: "M212 765h82v-100q42 -3 82 -23q41 -22 68 -52l-66 -84q-44 54 -105 54q-45 0 -68 -24q-19 -19 -19 -47t26 -47q15 -11 82 -41q5 -2 23.5 -10t27.5 -12.5t23.5 -12t25.5 -16t21 -17.5q51 -48 51 -124q0 -91 -60 -149q-45 -45 -112 -58v-112h-82v110q-70 8 -127 46 q-43 29 -73 73l75 77q27 -40 57 -60q38 -28 91 -28q49 0 76 26q25 25 25 62q0 34 -23 55q-13 13 -72 39q-97 43 -133 77q-47 44 -47 115t45 122q43 47 106 61v100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro.fitted",
    unicode: "\uF5F6",
    horizAdvX: 618,
    d: "M573 172v-146q-76 -41 -184 -41q-150 0 -230 87q-54 58 -65 139h-75l36 90h30q-5 33 0 63h-66l36 90h42q19 85 80 143q88 85 233 85q97 0 173 -44l-51 -109q-55 35 -130 35q-42 0 -74 -11.5t-50 -30.5t-27.5 -35t-14.5 -33h268l-36 -90h-249q-4 -36 0 -63h231l-36 -90 h-176q13 -55 59.5 -81.5t105.5 -26.5q107 0 170 69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent.fitted",
    unicode: "\uF5F7",
    horizAdvX: 385,
    d: "M197 655h82v-93q43 -2 81 -22v-123q-36 44 -95 44q-50 0 -84 -32q-37 -35 -37 -96t37 -95q31 -29 82 -29q64 0 97 44v-124q-39 -19 -81 -21v-95h-82v93q-72 10 -121 61q-62 65 -62 167q0 103 66 169q49 49 117 61v91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling.fitted",
    unicode: "\uF5F8",
    horizAdvX: 597,
    d: "M168 246h-113v88h65q-37 67 -37 128q0 94 63 154q68 66 177 66t172 -63q59 -59 59 -167v-12h-132q1 5 1 17q0 55 -29 84q-27 27 -72 27q-48 0 -77 -29q-32 -32 -32 -84q0 -41 23 -89l16 -32h148v-88h-120q7 -26 7 -50q0 -37 -12 -66l37 -13q80 -28 106 -28q48 0 61 54 l89 -19q-20 -84 -72 -118q-33 -21 -80 -21q-45 0 -118 25q-80 26 -110 26q-52 0 -68 -45l-94 17q14 53 54 90q36 33 87 40q11 25 11 49q0 27 -10 59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen.fitted",
    unicode: "\uF5F9",
    horizAdvX: 595,
    d: "M432 667h144l-129 -213h88v-90h-142l-36 -63h178v-90h-178v-211h-120v211h-178v90h178l-36 63h-142v90h88l-129 213h144l135 -234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin.fitted",
    unicode: "\uF5FA",
    horizAdvX: 551,
    d: "M233 347h-60l16 86h60l24 130q16 87 58 129q46 48 124 48q49 0 87 -19l-20 -107q-27 15 -55 15q-26 0 -45 -17q-19 -18 -26 -60l-23 -119h108l-16 -86h-108l-46 -266q-14 -77 -30 -123.5t-50 -79.5q-59 -58 -174 -58q-26 0 -49 4l19 112q17 -3 32 -3q51 0 80 26 q32 28 51 141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4.fitted",
    unicode: "\uF5FB",
    horizAdvX: 519,
    d: "M120 515l-68 89q37 31 83 52q60 26 127 26q97 0 146 -46q44 -43 44 -102q0 -43 -26 -80h70v-90h-142l-65 -63h207v-90h-277q-18 -21 -18 -48q0 -29 24 -46q20 -14 53 -14q44 0 78 24q29 20 50 53l80 -88q-36 -45 -90 -75q-61 -32 -140 -32q-84 0 -132 41q-50 42 -50 104 q0 47 21 81h-74v90h138l65 63h-203v90h276q24 23 24 53q0 31 -22 49q-21 17 -52 17q-41 0 -80 -23q-27 -15 -47 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6.fitted",
    unicode: "\uF5FC",
    horizAdvX: 545,
    d: "M287 667q62 0 101.5 -10.5t74.5 -40.5q68 -60 68 -163q0 -89 -55 -144q-61 -59 -169 -59h-84v-63h184v-90h-184v-97h-130v97h-70v90h70v63h-70v109h70v308h194zM223 555v-196h53q57 0 85 21q36 28 36 78q0 49 -37 76q-30 21 -92 21h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8.fitted",
    unicode: "\uF5FD",
    horizAdvX: 458,
    d: "M444 418h-150v-418h-130v418h-150v112h430v-112zM444 575h-430v92h430v-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF639",
    unicode: "\uF639",
    horizAdvX: 574,
    d: "M287 -15q-107 0 -182.5 92.5t-75.5 256.5q0 163 75.5 255.5t182.5 92.5t182.5 -92.5t75.5 -256.5q0 -163 -75.5 -255.5t-182.5 -92.5zM287 570q-49 0 -88.5 -58.5t-39.5 -177.5t39 -178t89 -59t89 59t39 178t-39.5 177.5t-88.5 58.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63A",
    unicode: "\uF63A",
    horizAdvX: 544,
    d: "M26 0l196 223q96 112 114 139q39 58 39 107q0 45 -28.5 73t-70.5 28q-48 0 -76 -32.5t-30 -78.5h-134q4 101 69 162t165 61q110 0 172.5 -63t62.5 -149q0 -48 -22 -96t-42 -72.5t-57 -64.5l-115 -125h241v-112h-484z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63B",
    unicode: "\uF63B",
    horizAdvX: 530,
    d: "M172 493h-122q9 89 69 139t148 50q96 0 152.5 -50t56.5 -134q0 -97 -77 -140q102 -42 102 -159q0 -100 -67.5 -157t-170.5 -57q-98 0 -165 56.5t-75 150.5h130q6 -43 35 -69t76 -26q52 0 79.5 31.5t27.5 74.5q0 42 -27.5 73t-83.5 31h-17v94h18q45 0 68 26.5t23 64.5 q0 40 -24 64t-64 24q-37 0 -63.5 -23t-28.5 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63C",
    unicode: "\uF63C",
    horizAdvX: 557,
    d: "M454 667v-437h78v-104h-78v-126h-122v126h-326v58l331 483h117zM160 230h172v254z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63D",
    unicode: "\uF63D",
    horizAdvX: 528,
    d: "M467 667v-112h-222l-24 -105q26 4 45 4q107 0 172 -67q59 -60 59 -160q0 -106 -68 -174t-183 -68q-87 0 -144 28q-43 21 -81 57l43 112q29 -39 69 -60q46 -25 97 -25q64 0 102 40q35 37 35 97q0 57 -39 92q-39 34 -104 34q-72 0 -144 -43l79 350h308z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63E",
    unicode: "\uF63E",
    horizAdvX: 547,
    d: "M299 685l105 -51l-162 -211q36 16 73 16q39 0 79 -15t68 -42q63 -59 63 -160q0 -95 -61 -161q-70 -76 -190 -76q-122 0 -190 68q-65 65 -65 162t84 208zM272 89q53 0 87 34q36 36 36 88q0 57 -37 92q-33 32 -86 32t-87 -36q-36 -37 -36 -87q0 -56 37 -90q35 -33 86 -33z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63F",
    unicode: "\uF63F",
    horizAdvX: 554,
    d: "M39 29l307 526h-310v112h514l-401 -687z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF640",
    unicode: "\uF640",
    horizAdvX: 522,
    d: "M374 348q55 -18 87 -63t32 -103q0 -85 -63.5 -141t-168.5 -56t-168.5 56t-63.5 141q0 58 32 103t87 63q-42 21 -69 58.5t-27 89.5q0 78 55 132t154 54t154 -54t55 -132q0 -52 -27 -89.5t-69 -58.5zM261 402q41 0 67 26t26 67t-26 67t-67 26t-67 -26t-26 -67t26 -67 t67 -26zM261 87q44 0 73 29.5t29 74.5t-29 74.5t-73 29.5t-73 -29.5t-29 -74.5t29 -74.5t73 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF641",
    unicode: "\uF641",
    horizAdvX: 547,
    d: "M248 -18l-105 51l159 208q-39 -13 -71 -13q-37 0 -77.5 15t-68.5 42q-63 59 -63 160q0 95 61 161q70 76 190 76q122 0 190 -68q65 -65 65 -162t-84 -208zM275 578q-53 0 -87 -34q-36 -36 -36 -88q0 -57 37 -92q33 -32 86 -32q52 0 87 36q36 38 36 87q0 55 -37 90 q-35 33 -86 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BA",
    unicode: "\uF6BA",
    horizAdvX: 360,
    d: "M50 285v112h260v-112h-260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BB",
    unicode: "\uF6BB",
    horizAdvX: 640,
    d: "M70 289v104h500v-104h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BC",
    unicode: "\uF6BC",
    horizAdvX: 840,
    d: "M70 289v104h700v-104h-700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6C3",
    unicode: "\uF6C3",
    d: "M160 -258l68 208l112 -16l-100 -204z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6C9",
    unicode: "\uF6C9",
    d: "M226 728l-56 50l140 142l90 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CA",
    unicode: "\uF6CA",
    d: "M250 842l120 88l60 -64l-180 -134l-180 134l60 64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CB",
    unicode: "\uF6CB",
    d: "M66 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5zM290 811q0 29 21.5 50.5t50.5 21.5t50.5 -21.5t21.5 -50.5t-21.5 -50.5t-50.5 -21.5t-50.5 21.5t-21.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CE",
    unicode: "\uF6CE",
    d: "M274 728l-174 122l90 70l140 -142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CF",
    unicode: "\uF6CF",
    d: "M198 921l90 -59l-144 -134l-56 40zM398 920l90 -58l-144 -134l-56 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D0",
    unicode: "\uF6D0",
    d: "M67 745v86h366v-86h-366z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D1",
    unicode: "\uF6D1",
    d: "M70 844l90 36q22 -58 90 -58t90 58l90 -36q-20 -52 -66.5 -82t-113.5 -30t-113.5 30t-66.5 82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D4",
    unicode: "\uF6D4",
    d: "M334 650l80 -38q-20 -56 -67 -79.5t-97 -23.5t-97 23.5t-67 79.5l80 38q6 -27 29.5 -45t54.5 -18q29 0 53 16t31 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6DC",
    unicode: "\uF6DC",
    horizAdvX: 284,
    d: "M112 0v555h-96v112h226v-667h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6DE",
    unicode: "\uF6DE",
    horizAdvX: 630,
    d: "M52 178v104h525v-104h-525z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nbspace",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphenminus",
    horizAdvX: 360,
    d: "M50 174v112h260v-112h-260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi1",
    horizAdvX: 238,
    d: "M58 433h122v-433h-122v433z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "S",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "O",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "G",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "C",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "Q",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04DD",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04C2",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04AF",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0497",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0442",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0436",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0434",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u040B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0409",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "6",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ".",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ",",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "9",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "8",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "6",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "5",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "4",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "3",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "2",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "1",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "0",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "1",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "1",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "5",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "4",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "3",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "4",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "1",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "3",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "1",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ":",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "8",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "3",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "2",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "0",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2122",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201D",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2018",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "*",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "W",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "T",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u2122",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "J",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "x",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "X",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "J",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "v",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "y",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "w",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "u",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "n",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "h",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "S",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2122",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "p",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "m",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "X",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "J",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u2122",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "v",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "q",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "p",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Q",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "J",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2122",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "x",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Q",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "*",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "Y",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u2122",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "N",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "N",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "N",
    u2: ".",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "y",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "w",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "t",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "W",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "T",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "S",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "v",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "M",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "J",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u2122",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "M",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "hyphenminus",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "x",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "q",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "p",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "m",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "Q",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "M",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "J",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2122",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2026",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ":",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2026",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "x",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "v",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "p",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "m",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ":",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "w",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "u",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "o",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "g",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "e",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "d",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "c",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "a",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "S",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2122",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "x",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "m",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "Q",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "M",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "Q",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u201D",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u2018",
    k: -114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u2026",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: ".",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u2026",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "v",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "J",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u2026",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "J",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: ".",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "v",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "X",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "Q",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u2026",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "J",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: ".",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u201D",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u2019",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "Y",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "V",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "f",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: ".",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "f",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: ".",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "w",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "J",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201C",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u2018",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "Y",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u2026",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "x",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: ".",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "Y",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "v",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "f",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "Q",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "J",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "J",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "v",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "f",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: ":",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "a",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "Y",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "T",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "J",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ":",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "f",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "J",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ":",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "w",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "g",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "e",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "Y",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "T",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "A",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "J",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "v",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10071.var.accented",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10097.var.accented",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10095.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10080.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10049.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10047.var.accented",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2122",
    k: -104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2018",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04EB",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E5",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04DD",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C2",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B3",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04AB",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u049D",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u049B",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0497",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0473",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0472",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u045E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0458",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0457",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0456",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0454",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0451",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044F",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044D",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044A",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0445",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0444",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0442",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0441",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u043E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u043C",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0436",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0434",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0424",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u041C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0414",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u040B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0409",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0404",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0402",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: ":",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u041B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u201C",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u042A",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u040B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0409",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0402",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0406",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0407",
    u2: "\u2122",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0407",
    u2: "\u0407",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u201C",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0409",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u2019",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u2018",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0409",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0472",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10071.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10085.var.accented",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10070.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10065.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10047.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10032.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10017.var.accented",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F1",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04DE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D0",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04BB",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0498",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0493",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0491",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045E",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0458",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0457",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0456",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0454",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0453",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0452",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0451",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0443",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0441",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0440",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0435",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0433",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0432",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0430",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u042D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u041E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0417",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0410",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10096.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10093.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F5",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04DD",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B9",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B7",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04A3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u049D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u049B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0497",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0473",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0449",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0448",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0447",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0446",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0436",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0427",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10071.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10097.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10080.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10049.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04F9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04F5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04EB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04C2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04AB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04AA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0472",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0456",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044F",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0449",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0447",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0445",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0444",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0434",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u042F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0421",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u041C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0414",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0409",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040F",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    g2: "hyphenminus",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2122",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2026",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u201D",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u201C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2018",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04F4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04DD",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04C2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B3",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0497",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0445",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0436",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0434",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0424",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0409",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "*",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10032.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04EA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04E8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04E6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04DE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0498",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0417",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0409",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0404",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10049.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10047.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04AA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0425",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0414",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u2122",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10071.var.accented",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10097.var.accented",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10095.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10080.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10049.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10047.var.accented",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2122",
    k: -104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2018",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04EB",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E5",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04DD",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C2",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B3",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04AB",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u049D",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u049B",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0497",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0473",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0472",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0458",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0457",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0456",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0454",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0451",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044F",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044D",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044A",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0445",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0444",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0442",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0441",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043C",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0436",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0434",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0424",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u041C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0414",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u040B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0409",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0404",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0402",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ":",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "hyphenminus",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BC",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BB",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BA",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "afii10017.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2014",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2013",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2012",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2011",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2010",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04D2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04D0",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u041B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0410",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0409",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "-",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0434",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04F5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04DD",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04C4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04C2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u049D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u049B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0497",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u045B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u045A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0446",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0436",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0424",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u2019",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u041B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0409",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u201C",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0418",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0419",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10071.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10085.var.accented",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10070.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10065.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10047.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10017.var.accented",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F1",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04DE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D0",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04BB",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0498",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0493",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0491",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045E",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0458",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0457",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0456",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0454",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0453",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0452",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0451",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0443",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0441",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0440",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0435",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0433",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0432",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0430",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u042D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0417",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0410",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10096.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10093.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F5",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04DD",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B9",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B7",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04A3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u049D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u049B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0497",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0473",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0449",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0448",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0447",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0446",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0436",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0427",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    g2: "afii10047.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04DE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0498",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u042D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0417",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2122",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u201C",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04F4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04B6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u2122",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041D",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u04B2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041F",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10071.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10085.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10070.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10065.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10047.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10017.var.accented",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04F3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04F1",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04EF",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04BB",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04AF",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0498",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u045E",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u045B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0459",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0452",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0451",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0443",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0435",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0430",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u042D",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0422",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u041B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0417",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0409",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ".",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ",",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "hyphenminus",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10097.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2122",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04F4",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B8",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B6",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0444",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0442",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u042A",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0427",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u041C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u040B",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0402",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u2122",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u201C",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u042A",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u040B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0402",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10096.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10093.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10085.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10080.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10074.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10070.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04A3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0499",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0493",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0491",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045E",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0454",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0453",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0452",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0451",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044E",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0444",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0443",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0441",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0440",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0435",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0433",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0432",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10065.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10047.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10037.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10032.var.accented",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10017.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F0",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EE",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EA",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E8",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E6",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DE",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D8",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AE",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AA",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0498",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042D",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0423",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0422",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0421",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041E",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0417",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0410",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u040E",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ";",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ":",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ".",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10071.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10097.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10095.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u201C",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F5",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DD",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B9",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0497",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0473",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0459",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0458",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0457",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0456",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0455",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0449",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0448",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0446",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042A",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0425",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0424",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u040B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0409",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0404",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0402",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10071.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10097.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10080.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10049.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04F9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04F5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04EB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04C2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04AB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04AA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0472",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0456",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044F",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0449",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0447",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0445",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0444",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0434",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u042F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0421",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u041C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0414",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0409",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10047.var.accented",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10037.var.accented",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10017.var.accented",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u201D",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u2019",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04F2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04F0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04EE",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04D2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04D0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0498",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0423",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0422",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0417",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0410",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u040E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10049.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u201C",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0425",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u040B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0402",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10085.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10080.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10070.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10065.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10047.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10032.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04EF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04EB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04EA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04DE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04D9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04D8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04D7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04D3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04D1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0498",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u045E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0451",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0443",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u043E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0435",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0430",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u042D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0417",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10097.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10049.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F4",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B8",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B6",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0444",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0442",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u042F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0427",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0424",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0404",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0402",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    g2: "hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BC",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BB",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BA",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2014",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2013",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2012",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2011",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2010",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "-",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2018",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0434",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0427",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0428",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    g2: "afii10047.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2019",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04DE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0498",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0417",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0409",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042B",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04F4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0409",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    g2: "afii10047.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04DE",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0498",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u042D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0417",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2122",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04B3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04B2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0445",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0425",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    g2: "afii10047.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u042D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u201C",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04B2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0425",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u201C",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u2018",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    g2: "afii10097.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    g2: "afii10095.var.accented",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u2026",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0459",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u044D",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u044A",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0442",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u043C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0425",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0424",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: ":",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: ".",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "hyphenminus",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BC",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BB",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BA",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "afii10017.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u201D",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2019",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2014",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2013",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2012",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2011",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2010",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04D2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04D0",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0459",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u043B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u041B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0410",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "-",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "afii10095.var.accented",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2122",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u201C",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2018",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04DD",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04C2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0497",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u044D",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u043C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0436",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0434",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u04B3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u0445",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04DD",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04C2",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0497",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u044A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0434",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0438",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0438",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0438",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0438",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0439",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0439",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0439",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0439",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "afii10095.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "afii10085.var.accented",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04F3",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04F1",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04EF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04DF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04AF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0499",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u045E",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u044D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0443",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u043B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0437",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04F5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04DD",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04C2",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04B9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04B7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04B2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04AB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0497",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0454",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u044A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0447",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0444",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0441",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0434",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0425",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    g2: "hyphenminus",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BC",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BB",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BA",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    g2: "afii10037.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u201D",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2019",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2014",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2013",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2012",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2011",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2010",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04EE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0423",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u040E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "-",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u201C",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2018",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    g2: "afii10037.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u201D",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u2019",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04EE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0459",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u043B",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0423",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u041B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u040E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0409",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    g2: "afii10080.var.accented",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u201C",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u2018",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04EB",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04E9",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04E7",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0473",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u043E",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0434",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0414",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    g2: "afii10085.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u201D",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u2019",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04EF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u045E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0443",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u043C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    g2: "afii10037.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04F2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04F0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04EE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0423",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u040E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u2026",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: ".",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u044A",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0442",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "hyphenminus",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BC",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BB",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BA",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10085.var.accented",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2014",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2013",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2012",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2011",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2010",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F3",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F1",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u045E",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0443",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u043B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ";",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "-",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ",",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10095.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2026",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AA",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044D",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044A",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0444",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0442",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0421",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ":",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ".",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    g2: "hyphenminus",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    g2: "afii10097.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u2026",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04AB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u044F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u044A",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0442",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0441",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0434",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: ".",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u201D",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u2019",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0422",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u040B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0402",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: ".",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: ",",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u2026",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04DC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04C1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04B3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0496",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0445",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0416",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10071.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10096.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10093.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10074.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10070.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10065.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10017.var.accented",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D2",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D0",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04C8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04A3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0493",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0491",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u045F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u045C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u045A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0459",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0457",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0456",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0453",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0451",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u044E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u044C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u044B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0449",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0448",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0446",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043B",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0439",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0438",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0435",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0433",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0432",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0430",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0410",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10080.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04EB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04E9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04E7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04B9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04B7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04B3",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0473",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0447",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0445",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0434",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u041C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    g2: "hyphenminus",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BC",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BB",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BA",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    g2: "afii10017.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u201D",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2019",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2014",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2013",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2012",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2011",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2010",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04D2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04D0",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0459",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u043B",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u041B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0410",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0409",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "-",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2122",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u201C",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2018",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04DD",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04C2",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0497",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0434",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    g2: "hyphenminus",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BC",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BB",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BA",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    g2: "afii10017.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u201D",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2019",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2014",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2013",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2012",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2011",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2010",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04D2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04D0",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0459",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u043B",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u041B",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0410",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0409",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "-",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2122",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u201C",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2018",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04DD",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04DC",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04C2",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04C1",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0497",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0496",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0434",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0416",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04DD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04C2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04AB",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0497",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u044A",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0442",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0441",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0436",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0434",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0425",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0459",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u043B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04F5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04DD",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04C2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04AB",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0497",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u045B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u044A",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0447",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0442",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0441",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0436",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u041C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04B3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0445",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u04B3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u0445",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "hyphenminus",
    k: -93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10097.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10095.var.accented",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u2026",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0459",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u044D",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u044A",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0442",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u043C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0425",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0424",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: ":",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: ".",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u044A",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0442",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0434",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\u0457",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10085.var.accented",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F3",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F1",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04EF",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04AF",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u045E",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0443",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04DD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04C2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04AB",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0497",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u044A",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0442",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0441",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0436",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0434",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0425",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10085.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10037.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F2",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F0",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04EF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04EE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04AF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04AE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0459",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0443",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u043B",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0423",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u040E",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10080.var.accented",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04EB",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04E9",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04E7",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04DD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04C2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04AB",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0497",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0473",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u044A",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0442",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0441",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u043E",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0436",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0434",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0425",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10095.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10085.var.accented",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10065.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04F3",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04F1",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04EF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04DF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04D3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04D1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04AF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0499",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u045E",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u044D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0443",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u043B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0437",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04F5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04DD",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04C2",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04B9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04B7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04B2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04AB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0497",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0454",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u044A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0447",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0444",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0441",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0434",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0425",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0459",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u043B",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    g2: "hyphenminus",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    g2: "afii10097.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u2026",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04AB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u044F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u044A",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0442",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0441",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0434",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: ".",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10047.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10037.var.accented",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10017.var.accented",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04F2",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04F0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04EE",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04DE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04D2",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04D0",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04AE",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0498",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u042D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0423",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0417",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0410",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u040E",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04B2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u201D",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u2019",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u043C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: ";",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: ",",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: "\u2026",
    k: 159
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: ":",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: ".",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0475",
    u2: ",",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0475",
    u2: "\u2026",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0475",
    u2: ".",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10096.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10093.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10085.var.accented",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10074.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10070.var.accented",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10037.var.accented",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10032.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10017.var.accented",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2019",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F3",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F2",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F1",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F0",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EF",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EE",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DF",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D9",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D7",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D2",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D0",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AF",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AE",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04A3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0499",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0459",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0453",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0446",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0443",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0440",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043D",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043B",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0437",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0435",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0432",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0423",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0422",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0410",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u040E",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ",",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10071.var.accented",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10097.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10095.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10080.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10049.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10047.var.accented",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2122",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u201C",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F5",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EB",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DD",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B9",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B7",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B3",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AB",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u049D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u049B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0497",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0493",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0491",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0473",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0472",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0458",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0457",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0456",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0454",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0451",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044F",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044D",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044A",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0449",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0448",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0447",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0445",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0444",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0442",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0441",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043C",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0439",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0438",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0436",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0434",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0433",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042A",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0424",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0414",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u040B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0409",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0404",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0402",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ":",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10097.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10095.var.accented",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u2026",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04F5",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04DD",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04C2",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B9",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B7",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0497",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0459",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044D",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044A",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0447",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0442",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u043C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0425",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0424",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: ":",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: ".",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10071.var.accented",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10097.var.accented",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10095.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10080.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10049.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10047.var.accented",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2122",
    k: -104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2018",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04EB",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E5",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04DD",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C2",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B3",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04AB",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u049D",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u049B",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0497",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0473",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0472",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0458",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0457",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0456",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0454",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0451",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044F",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044D",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044A",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0445",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0444",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0442",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0441",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u043E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u043C",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0436",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0434",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0424",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u041C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0414",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u040B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0409",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0404",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0402",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: ":",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    g2: "afii10097.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    g2: "afii10095.var.accented",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u2026",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0459",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u044D",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u044A",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0442",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u043C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0425",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0424",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: ":",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: ".",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04F5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04DD",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04C4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04C2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u049D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u049B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0497",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u045B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u045A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0447",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0446",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0436",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0424",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04DD",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04C2",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0497",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u044A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0434",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u2019",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u041B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0409",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u201C",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04B2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10071.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10085.var.accented",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10070.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10065.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10047.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10032.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10017.var.accented",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F1",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04DE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D0",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04BB",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0498",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0493",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0491",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045E",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0458",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0457",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0456",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0454",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0453",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0452",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0451",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0443",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0441",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0440",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0435",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0433",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0432",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0430",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u042D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u041E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0417",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0410",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10096.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10093.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F5",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04DD",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B9",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B7",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04A3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u049D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u049B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0497",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0473",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0449",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0448",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0447",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0446",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0436",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0427",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10095.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10085.var.accented",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F3",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F1",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04EF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04DF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04AF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0499",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u045E",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u044D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0443",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u043B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0437",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04DD",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04C2",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04B9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04B7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04B2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04AB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0497",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0454",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u044A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0447",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0444",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0441",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0434",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0425",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10071.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10085.var.accented",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10070.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10065.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10047.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10032.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10017.var.accented",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F1",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04DE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D0",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04BB",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0498",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0493",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0491",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045E",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0458",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0457",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0456",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0454",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0453",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0452",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0451",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0443",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0441",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0440",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0435",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0433",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0432",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0430",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u042D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u041E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0417",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0410",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10096.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10093.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F5",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04DD",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B9",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B7",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04A3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u049D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u049B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0497",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0473",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0449",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0448",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0447",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0446",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0436",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0427",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10095.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10085.var.accented",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F3",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F1",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04EF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04DF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04AF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0499",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u045E",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u044D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0443",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u043B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0437",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04DD",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04C2",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04B9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04B7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04B2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04AB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0497",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0454",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u044A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0447",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0444",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0441",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0434",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0425",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u2122",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u201C",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u042A",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u040B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0402",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u044A",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0442",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "hyphenminus",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\uF6BC",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\uF6BB",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\uF6BA",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10032.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10017.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2014",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2013",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2012",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2011",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2010",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04EA",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04D8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04D2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04D0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u041E",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0410",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "-",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10071.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10097.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10080.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10049.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04F9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04F5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04EB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04AF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04AB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04AA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0472",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0456",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0455",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044F",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0449",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0447",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0445",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0444",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u043C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0434",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u042F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0424",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0421",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u041C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0414",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0409",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\uF6BC",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\uF6BB",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\uF6BA",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2014",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2013",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2012",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2011",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2010",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "-",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    g2: "hyphenminus",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    g2: "afii10097.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2026",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04AB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0455",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u044F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u044A",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0442",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0441",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0434",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: ".",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10085.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10080.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10070.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10065.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10047.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10032.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04EF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04EB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04EA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04E8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04E7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04E6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04DE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04D9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04D8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04D7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04D3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04D1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04AF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0498",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u045E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0451",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0443",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u043E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0435",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0430",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u042D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u041E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0417",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10097.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10049.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F4",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B8",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B6",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0444",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0442",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u042F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0427",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0424",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0404",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0402",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10096.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10093.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10074.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10065.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10017.var.accented",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D2",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D0",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04C8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04A3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0493",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0491",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u045F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u045C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u045A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0459",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0457",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0456",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0453",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u044E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u044C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u044B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0449",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0448",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0446",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043B",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0439",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0438",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0433",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0432",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0430",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0410",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10080.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04EB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04E9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04E7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04B9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04B7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04B3",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0473",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0447",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0445",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0434",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u041C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B8",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04AE",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0472",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04F5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04DD",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04C4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04C2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u049D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u049B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0497",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u045B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u045A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0447",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0446",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0436",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0424",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04DD",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04C2",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0497",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u044A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0434",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10071.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10085.var.accented",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10070.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10065.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10047.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10032.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10017.var.accented",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F1",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04DE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D0",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04BB",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0498",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0493",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0491",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045E",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0458",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0457",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0456",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0454",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0453",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0452",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0451",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0443",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0441",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0440",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0435",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0433",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0432",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0430",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u042D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u041E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0417",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0410",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10096.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10093.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F5",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04DD",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B9",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B7",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04A3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u049D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u049B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0497",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0473",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0449",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0448",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0447",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0446",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0436",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0427",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10095.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10085.var.accented",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F3",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F1",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04EF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04DF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04AF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0499",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u045E",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u044D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0443",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u043B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0437",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04DD",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04C2",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04B9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04B7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04B2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04AB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0497",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0454",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u044A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0447",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0444",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0441",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0434",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0425",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C7",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "afii10085.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04EF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0443",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "hyphenminus",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u2122",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u2026",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u201D",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u201C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u2018",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04DD",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04C2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B3",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0497",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0445",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0436",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0434",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0424",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0409",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "*",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u201C",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u2018",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "afii10085.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04EF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0443",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "hyphenminus",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u2122",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u2026",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u201D",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u201C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u2018",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04DD",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04C2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B3",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0497",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0445",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0436",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0434",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0424",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0409",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "*",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u201C",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u2018",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u04B3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u0445",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u04B2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04F5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04DD",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04C4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04C2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u049D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u049B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0497",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u045B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u045A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0447",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0446",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0436",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0424",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04DD",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04C2",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0497",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u044A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0434",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u2019",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u041B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0409",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u201C",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04B2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E2",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E3",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E3",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E3",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E3",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E4",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E5",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E5",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E5",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E5",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u04B2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u201D",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u2019",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u043C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u04B2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u201D",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u2019",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u043C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u04B2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u201D",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u2019",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u043C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10071.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10097.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10080.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10049.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04F9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04F5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04EB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04C2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04AB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04AA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0472",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0456",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044F",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0449",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0447",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0445",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0444",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u043C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0434",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u042F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0421",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u041C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0414",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0409",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    g2: "hyphenminus",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    g2: "afii10097.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u2026",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04AB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u044F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u044A",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0442",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0441",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0434",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: ".",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10071.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10097.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10080.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10049.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04F9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04F5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04EB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04C2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04AB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04AA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0472",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0456",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044F",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0449",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0447",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0445",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0444",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u043C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0434",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u042F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0421",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u041C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0414",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0409",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    g2: "hyphenminus",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    g2: "afii10097.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u2026",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04AB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u044F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u044A",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0442",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0441",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0434",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: ".",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10071.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10097.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10080.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10049.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04F9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04F5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04EB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04C2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04AB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04AA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0472",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0456",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044F",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0449",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0447",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0445",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0444",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u043C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0434",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u042F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0421",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u041C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0414",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0409",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    g2: "hyphenminus",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    g2: "afii10097.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u2026",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04AB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u044F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u044A",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0442",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0441",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0434",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: ".",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F4",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F8",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04DD",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04C2",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04AF",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0497",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0442",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0436",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0434",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u040B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0409",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04DD",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04C2",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04AF",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0497",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0442",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0436",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0434",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u040B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0409",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04DD",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04C2",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04AF",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0497",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0442",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0436",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0434",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u040B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0409",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04DD",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04C2",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04AF",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0497",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0442",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0436",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0434",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u040B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0409",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04DD",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04C2",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04AF",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0497",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0442",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0436",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0434",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u040B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0409",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "J",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10071.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10096.var.accented",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10093.var.accented",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10085.var.accented",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10080.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10074.var.accented",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10070.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10065.var.accented",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10047.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10032.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10017.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F9",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F3",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EF",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EB",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EA",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E9",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E8",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E7",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E6",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04DE",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D9",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D8",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D7",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D3",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D2",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D1",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D0",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04C8",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AF",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AB",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AA",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04A3",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0498",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0493",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0491",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045F",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045E",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045C",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045A",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0457",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0456",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0453",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0451",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044E",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044C",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044B",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0449",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0448",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0446",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0444",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0443",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0441",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043F",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043E",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043D",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043B",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043A",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0439",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0438",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0435",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0433",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0432",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0430",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u042D",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0421",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u041E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u041B",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0417",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0410",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "y",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "s",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "o",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "g",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "e",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "d",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "c",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "a",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "S",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "A",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ",",
    k: 261
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0473",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0472",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0459",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0454",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043C",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0434",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0424",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u041C",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0414",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0409",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0404",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "v",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "q",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "J",
    k: 142
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ".",
    k: 219
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0422",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u040B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0402",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "a",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "Y",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "W",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "V",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "T",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "J",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "Y",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "A",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "J",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10085.var.accented",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10037.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10032.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F3",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F2",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F1",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F0",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04EF",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04EE",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04EA",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04E8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04E6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04DE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04D8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AF",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AE",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0498",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u045E",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0443",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0423",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0422",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u041E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0417",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u040E",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0404",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Y",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "W",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "T",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "S",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10047.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F4",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B9",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B8",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B7",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B6",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AA",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0472",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0447",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0444",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0442",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u042D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0427",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0424",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0421",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u040B",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0402",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "Y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "afii10085.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04EF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0443",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "hyphenminus",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u2122",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u2026",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u201D",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u201C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u2018",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04DD",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04C2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B3",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0497",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0445",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0436",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0434",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0424",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0409",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "*",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10026.var.accented",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u04B2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10071.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10097.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10080.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10049.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04F9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04F5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04EB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04C2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04AB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04AA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0472",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0456",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044F",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0449",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0447",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0445",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0444",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u043C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0434",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u042F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0421",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u041C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0414",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0409",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10045.var.accented",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    g2: "afii10047.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04DE",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0498",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u042D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0417",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2122",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04B3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04B2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0445",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0425",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    g2: "afii10047.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    g2: "afii10017.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04D2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04D0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u042D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0410",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u201C",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04B2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0425",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10049.var.accented",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u201C",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u2018",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u04B3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u0445",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u201D",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u2019",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u043C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    g2: "hyphenminus",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    g2: "afii10097.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u2026",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04AB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u044F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u044A",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0442",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0441",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0434",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: ".",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04B3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0445",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u04B3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u0445",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10071.var.accented",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10095.var.accented",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10074.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10070.var.accented",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10065.var.accented",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10047.var.accented",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10032.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10017.var.accented",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04EA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04DF",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04DE",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D9",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D3",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D2",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D0",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04C8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04A3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0499",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0498",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0493",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0491",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045F",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0459",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0458",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0457",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0456",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0454",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0453",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0451",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044D",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0448",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0446",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0440",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043F",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043B",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0439",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0438",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0437",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0435",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0433",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0432",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0430",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u042D",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u041E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u041B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0417",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0410",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0409",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0404",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: ";",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: ".",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: ",",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10097.var.accented",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10096.var.accented",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10093.var.accented",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10080.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u2026",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04EB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04C2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04B9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04B7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04B3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04AB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04AA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0472",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044F",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0449",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0447",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0445",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0444",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0441",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043E",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0434",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0431",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0421",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0414",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: ",",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: "\u2026",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: ".",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04DD",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04C2",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04AF",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0497",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0442",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0436",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0434",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u040B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0409",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04DD",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04C2",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04AF",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0497",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0442",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0436",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0434",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u040B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0409",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04DD",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04C2",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04AF",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0497",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0442",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0436",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0434",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u040B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0409",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    g2: "afii10085.var.accented",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04F3",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04F1",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04EF",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u045E",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0443",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04DD",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04C2",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04AF",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0497",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0442",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0436",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0434",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u040B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0409",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "comma,period",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "G",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "O",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "S",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "T",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "U",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "W",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "Y",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "w",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "y",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "quoteright,quotedblright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "T",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "quoteright,quotedblright",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "T",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "W",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "Y",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "quoteright,quotedblright",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "z",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "Z",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "T",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "w",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "a",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "c",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "e",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "g",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "u",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Y",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "quoteright,quotedblright",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Z",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "z",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "C",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "G",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "O",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "S",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "U",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "w",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "y",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "d",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "e",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "g",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "u",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "o",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "O",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "U",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "w",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "y",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "quoteright,quotedblright",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "guilsinglright",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "T",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "W",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "Y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "quoteright,quotedblright",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "Z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "Y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "quoteright,quotedblright",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "S",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "T",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "W",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "Y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "quoteright,quotedblright",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "comma,period",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "G",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "O",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "S",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "T",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "Y",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "w",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "y",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "z",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "s",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "d",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "e",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "g",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "o",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "colon,semicolon",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "h,n",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "r",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U",
    g2: "y",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U",
    g2: "A",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U",
    g2: "Z",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U",
    g2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "e",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "g",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "o",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "h,n",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "r",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "comma,period",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "w",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "y",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "z",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "s",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "d",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "e",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "u",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "o",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "colon,semicolon",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "h,n",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "r",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "comma,period",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "C",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "G",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "O",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "S",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "T",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "V",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "W",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "w",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "y",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "z",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "s",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "a",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "c",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "d",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "e",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "g",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "u",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "o",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "colon,semicolon",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "h,n",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "r",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "O",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "S",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "s",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "a",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "d",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "e",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "g",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "u",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "o",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "T",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "Y",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "quoteright,quotedblright",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "T",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "Y",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "comma,period",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "Y",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "w",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "y",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "t",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "comma,period",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "Y",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "quoteright,quotedblright",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "a",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "G",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "O",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "w",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "y",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "quoteright,quotedblright",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "t",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "comma,period",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "Y",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "comma,period",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "T",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "W",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "Y",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "A",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "d",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "e",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "g",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "u",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "o",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "quoteright,quotedblright",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "Y",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "quoteright,quotedblright",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "Y",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "w",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "quoteright,quotedblright",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "comma,period",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "T",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "Y",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "w",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "y",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "z",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "a",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "d",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "e",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "g",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "t",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "T",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "W",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "Y",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "quoteright,quotedblright",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "s",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "Y",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "w",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "y",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "t",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "Y",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "comma,period",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "T",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "Y",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "a",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "e",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "o",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "t",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "comma,period",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "T",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "Y",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "y",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "quoteright,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "a",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "e",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "t",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "colon,semicolon",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "T",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "Y",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "w",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "a",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "g",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "t",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "T",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "V",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "W",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "Y",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10051,afii10060,afii10036",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "Y",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "A",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10058,afii10029",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10077,afii10106",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "comma,period",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "quoteright,quotedblright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10058,afii10029",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10077,afii10106",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10051,afii10060,afii10036",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "comma,period",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "quoteright,quotedblright",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "colon,semicolon",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10051,afii10060,afii10036",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10058,afii10029",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10077,afii10106",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10082,afii10105",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10099,afii10108,uni04BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023,afii10022,uni04D6,afii10022.var.accented,afii10023.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10082,afii10105",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10099,afii10108,uni04BB",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "quoteright,quotedblright",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "quoteright,quotedblright",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10051,afii10060,afii10036",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "comma,period",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "quoteright,quotedblright",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "colon,semicolon",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10058,afii10029",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10077,afii10106",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10082,afii10105",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10099,afii10108,uni04BB",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "quoteright,quotedblright",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10051,afii10060,afii10036",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10058,afii10029",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "quoteright,quotedblright",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10066,afii10080,afii10082,afii10086,afii10095,afii10096,afii10846,uni04E7,uni04E9,uni04EB,afii10080.var.accented,afii10095.var.accented,afii10096.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10066,afii10080,afii10082,afii10086,afii10095,afii10096,afii10846,uni04E7,uni04E9,uni04EB,afii10080.var.accented,afii10095.var.accented,afii10096.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "comma,period",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "colon,semicolon",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10051,afii10060,afii10036",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10077,afii10106",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "quoteright,quotedblright",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10051,afii10060,afii10036",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10058,afii10029",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10077,afii10106",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074,afii10075,afii10079,afii10081,afii10089,afii10090,afii10093,afii10097,afii10193,uni04A3,uni04B7,uni04B9,uni04BB,uni04C8,uni04E3,uni04E5,uni04F5,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10097.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074,afii10075,afii10079,afii10081,afii10089,afii10090,afii10093,afii10097,afii10193,uni04A3,uni04B7,uni04B9,uni04BB,uni04C8,uni04E3,uni04E5,uni04F5,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10097.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10058,afii10029",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10077,afii10106",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "comma,period",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "quoteright,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "colon,semicolon",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10058,afii10029",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10077,afii10106",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10051,afii10060,afii10036",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10099,afii10108,uni04BB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10051,afii10060,afii10036",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 11
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuturaCyrillicDemi);
export default __webpack_public_path__ + "static/media/FuturaCyrillicDemi.72a701d67ee52f0fc85884492e0788ae.svg";
export { ForwardRef as ReactComponent };